<template>
  <div style="margin: 0; padding: 0; box-sizing: border-box">
    <!-- <button class="btn btn-primary" @click="isSidebarOpen = !isSidebarOpen"
      style="position: fixed; top: 4px; left: 175px; z-index: 1001; padding: 5px 15px;">
      <i class="fas" :class="isSidebarOpen ? 'fa-times' : 'fa-bars'"></i>
    </button> -->
    <button
      @click="isSidebarOpen = !isSidebarOpen"
      class="btn btn-primary d-flex align-items-center justify-content-center"
      style="position: fixed;top: 40%;width: 20px;height: 80px;z-index: 1100;border-radius: 0 5px 5px 0;transition: left 0.3s ease; padding: 0!important;"
      :style="{ left: isSidebarOpen ? '270px' : '0px' }"
    >
      <i
        :class="[
          'fa-solid',
          isSidebarOpen ? 'fa-angle-left' : 'fa-angle-right'
        ]"
        style="font-size: 22px;"
      ></i>
    </button>
    <!-- <h3 style="font-family: 'Poppins' ;position: fixed; z-index: 9999; left: 50%; transform: translateX(-50%);top: 0; margin: 7px 0;color: white;">{{ selectedWorkspaceName }}</h3> -->
    <div class="container-fluid row p-0" style="margin: 0 !important">
      <!-- Sidebar -->
      <div class="bg-light p-0" :class="{ 'd-none': !isSidebarOpen }" id="sidebar" style="
          width: 270px;
          position: fixed;
          top: 0;
          bottom: 0;
          /* z-index: 1000; */
          margin-top: 40px;
        ">
        <div class="sidebar">
          <!-- Sidebar Header -->
          <aside>
            <div class="sidebar-menu">
              <div class="d-flex justify-content-between align-items-center mb-5">
                <h3 class="m-0 p-0">Yangi yaratish</h3>
                <button @click="workSpaceInput = !workSpaceInput" class="btn btn-primary"><i :class="workSpaceInput ? 'fas fa-minus' : 'fas fa-plus'"></i></button>
              </div>
              <div class="search" v-if="workSpaceInput">
                <div class="toggle-buttons">
                  <button
                    class="toggle-btn"
                    :class="{ active: activeTab === 'project' }"
                    @click="activeTab = 'project'"
                  >
                    Loyiha
                  </button>

                  <button
                    class="toggle-btn"
                    :class="{ active: activeTab === 'structure' }"
                    @click="activeTab = 'structure'"
                  >
                    Tuzilma
                  </button>

                  <div class="slider" :style="sliderStyle"></div>
                </div>

                <transition name="slide-fade" mode="out-in">
                  <form :key="activeTab" class="search-form" @submit.prevent="createWorkSpace()">
                    <input :placeholder="activeTab === 'structure' ? 'Tuzilma nomini kiriting ...' : 'Loyiha nomini kiriting ...'"
                      type="text" v-model="newWorkSpaceName" required />
                      
                    <template v-if="myTeams.length > 0">
                      <select v-model="selectedStructureId" @change="handleStructureChange" required class="custom-select">
                        <option value="" disabled selected>
                          {{ activeTab === 'structure' ? 'Tuzilmaga' : 'Loyihaga' }} jamoa tanlang
                        </option>
                        <option v-for="t in myTeams" :key="t.id" :value="t.id">
                          {{ t.name }}
                        </option>
                        <option value="CREATE_NEW" style="color: #3b82f6; font-weight: bold;">
                          + Yangi jamoa yaratish
                        </option>
                      </select>
                    </template>
                    <template v-else>
                      <div @click="orgChartModel = true" style="cursor: pointer; padding: 10px; border: 1px dashed #cbd5e1; border-radius: 6px; text-align: center; color: #64748b; font-size: 13px; transition: 0.2s;" onmouseover="this.style.borderColor='#3b82f6'; this.style.backgroundColor='#f8fafc';" onmouseout="this.style.borderColor='#cbd5e1'; this.style.backgroundColor='transparent';">
                        Sizda mavjud jamoa mavjud emas, <br><strong style="color: #3b82f6;">jamoa yarating</strong>
                      </div>
                    </template>

                    <button type="submit" :disabled="myTeams.length === 0">
                      {{ activeTab === 'structure'
                        ? 'Tuzilmani yaratish'
                        : 'Loyihani yaratish'
                      }}
                    </button>
                  </form>
                </transition>
              </div>

              <hr style="color: #003974;">
              <p @click="setWorkspace(0), selectedWorkspaceName = 'Barcha topshiriqlar'" class="all-projects" :class="{ active: activeWorkspaceId == 0 }">
                <i class="fa-solid fa-reply-all mr-3 fs-15"></i>Barchasi</p>
              <!-- <p @click="setWorkspace(0), selectedWorkspaceName = 'Umumiy topshiriqlar'" class="all-projects" :class="{ active: activeWorkspaceId == 0 }"><i class="fa-solid fa-list-check mr-3 fs-15"></i>Umumiy topshiriqlar</p> -->
              <span v-if="myWorkSpaces.filter(w => w.is_structure == true).length>0" class="sidebar-title">Tashkiliy Tuzilmalar</span>



              <!-- Tuzilmalar -->
              <ul v-for="(item, index) in [
              ...myWorkSpaces.filter(w => (w.user_id === userId && w.is_structure === true)),
              ...myWorkSpaces.filter(w => (w.is_structure === true && w.user_id != userId)),
              ]" :key="item.id" style="margin: 0;"
              >
                <li @click="setWorkspace(item.id), selectedWorkspaceName = item.name" style="margin: 0;" :class="{ active: activeWorkspaceId == item.id }" :title="item.user_id === userId && item.is_structure === true ? 'Tuzilma/Bo‘lim' : ''">
                  <a style="position: relative;">
                    <!-- <div v-if="item.user_id == userId && item.is_structure === true" class="project-thumbtack">
                      <i class="fa-solid fa-thumbtack m-0"></i>
                    </div> -->
                    <div class="project-index">
                      <span v-if="item.is_structure === true"><i class="fa-solid fa-sitemap ml-1"></i></span>
                      <span v-else>{{ index === 0 ? index + 1 : index }}</span>
                    </div>
                    <p class="m-0 fs-15">{{ item.name }}</p>
                  </a>
                </li>
              </ul>

              <!-- Loyihalar -->
              <span class="sidebar-title">Loyihalar</span>
              <ul v-for="(item, index) in [
              ...myWorkSpaces.filter(w => (w.is_structure === false))
              ]" :key="item.id" style="margin: 0;"
              >
                <li @click="setWorkspace(item.id), selectedWorkspaceName = item.name" style="margin: 0;" :class="{ active: activeWorkspaceId == item.id }">
                  <a style="position: relative;">
                    <div v-if="item.user_id == userId && item.is_structure === true" class="project-thumbtack">
                      <i class="fa-solid fa-thumbtack m-0"></i>
                    </div>
                    <div class="project-index">
                      <span v-if="item.user_id == userId && item.is_structure === true"><i class="fa-solid fa-sitemap ml-1"></i></span>
                      <span v-else>{{ index + 1 }}.</span>
                    </div>
                    <p class="m-0 fs-15">{{ item.name }}</p>
                  </a>
                </li>
              </ul>
            </div>

            <!-- <div class="sidebar-menu">
              <h3></h3>
              <ul>Kategoriyalar
                <li><a href="#"><i class="fas fa-code"></i> Dasturlash</a></li>
                <li><a href="#"><i class="fas fa-paint-brush"></i> Dizayn</a></li>
                <li><a href="#"><i class="fas fa-chart-line"></i> Marketing</a></li>
                <li><a href="#"><i class="fas fa-mobile-alt"></i> Mobil ilovalar</a></li>
                <li><a href="#"><i class="fas fa-database"></i> Ma'lumotlar bazasi</a></li>
              </ul>
            </div> -->
          </aside>
          <!-- Sidebar Footer -->
          <div class="p-3 border-top mt-auto d-flex align-items-center"
            style="bottom: 0; left: 0; position: absolute; width: 100%; padding: 1rem; cursor: pointer;">
            <img :src="`https://api.task-board.uz/storage/user/avatar/${currentUser.avatar}`" alt="User" class="rounded-circle me-2" width="40"
              height="40" style="object-fit: cover; object-position: center;" />
            <div>
              <div class="fw-semibold">{{ currentUser?.firstname + ' ' + currentUser?.lastname }}</div>
              <small class="text-muted">Profile</small>
            </div>
          </div>

        </div>
      </div>

      <div class="main-content" :style="{
        width: isSidebarOpen ? 'calc(100% - 270px)' : '100%',
        'margin-left': isSidebarOpen ? '270px' : '0',
        transition: 'width 0.3s ease, margin-left 0.3s ease',
      }">
        <div class="card control-panel" style="position: relative; z-index: 99;">
          <div class="card-body" style="padding: 20px 20px;">
            <div class="row g-2 justify-content-between">
              <div class="col-6 m-0">
                <div class="hstack gap-2">
                  <!-- <button class="btn btn-primary" @click="downloadExcel" style="border-radius: 5px; padding: 5px 10px;"> -->
                  <!-- Split button: asosiy + yordamchi (o'zim uchun) -->
                  <div class="btn-group create-task-split">
                    <div :class="{'not-allowed' : !isCreateTaskDisabled}" :title="!isCreateTaskDisabled ? 'Yangi topshiriq yaratish uchun loyiha tanlanmagan yoki sizda bajaruvchi xodim mavjud emas!' : ''">
                      <button :disabled="!isCreateTaskDisabled" class="btn btn-primary split-main" @click="openCreateTaskModal">
                        Yangi topshiriq yaratish
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary split-toggle dropdown-toggle dropdown-toggle-split"
                      data-bs-toggle="dropdown"
                      data-bs-reference="parent"
                      aria-expanded="false"
                      :disabled="!isSelfTaskEnabled"
                      :title="isSelfTaskEnabled ? 'Qo\'shimcha imkoniyatlar' : 'Loyiha tanlanmagan'"
                    >
                      <span class="visually-hidden">Qo'shimcha</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow-lg border-0 split-menu">
                      <li>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)" @click="openSelfTaskModal">
                          <span class="split-menu-icon"><i class="fa-solid fa-user-check"></i></span>
                          <span>
                            <span class="split-menu-title">Faqat o'zim uchun</span>
                            <small class="split-menu-desc">Ijrochi sifatida o'zingiz biriktirilasiz</small>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  
                  <!-- Shablonlar modul (Dropdown format) -->
                  <div class="dropdown" v-if="isCreateTaskDisabled">
                    <button class="btn dropdown-toggle d-flex align-items-center" type="button" id="templatesDropdown" data-bs-toggle="dropdown" aria-expanded="false" style="background-color: rgba(64, 81, 137, 0.08); color: #405189; border: none; border-radius: 5px; padding: 6px 12px; font-weight: 600;">
                      <i class="fa-solid fa-layer-group me-2" style="font-size: 13px;"></i> Shablonlar
                    </button>
                    <ul class="dropdown-menu shadow-lg border-0" aria-labelledby="templatesDropdown" style="width: 320px; border-radius: 12px; padding: 10px; margin-top: 5px; z-index: 9999 !important;background-color: #fff;">
                      <li><h6 class="dropdown-header text-uppercase fw-bold" style="font-size: 11px; color: #878a99; letter-spacing: 0.5px;">Tayyor shablonlar</h6></li>
                      <li v-for="(template, idx) in taskTemplates" :key="idx" class="px-2">
                        <div class="d-flex align-items-center py-2 px-2 mb-1" @click="useTemplate(template)" onmouseover="this.style.backgroundColor='#f3f6f9'" onmouseout="this.style.backgroundColor='transparent'" style="border-radius: 8px; cursor: pointer; transition: background-color 0.2s;">
                          <div class="avatar-xs me-3 flex-shrink-0">
                            <span class="avatar-title text-primary rounded-circle" style="background-color: rgba(64, 81, 137, 0.1); font-size: 14px; width: 32px; height: 32px;">
                              <i :class="template.icon || 'fa-solid fa-file-lines'"></i>
                            </span>
                          </div>
                          <div style="flex: 1; overflow: hidden;">
                            <h6 class="mb-1 text-truncate" style="font-size: 13px; font-weight: 600; color: #495057;">{{ template.name }}</h6>
                            <p class="text-muted mb-0" style="font-size: 11px; white-space: normal; line-height: 1.3; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">{{ template.description }}</p>
                          </div>
                        </div>
                      </li>
                      <li><hr class="dropdown-divider my-2"></li>
                      <li class="px-2 mt-1">
                        <div class="text-center text-primary py-2" @click="openTemplateManager" onmouseover="this.style.backgroundColor='#f3f6f9'" onmouseout="this.style.backgroundColor='transparent'" style="font-size: 12px; font-weight: 600; border-radius: 8px; cursor: pointer; transition: background-color 0.2s;">
                          <i class="fa-solid fa-gear me-1"></i> Shablonlarni boshqarish
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="search-box">
                  <div style="
                      position: relative;
                      display: inline-block;
                      width: 200px;
                    ">
                    <input type="text" style="
                        padding: 5px 25px 5px 10px;
                        width: 100%;
                      " class="form-control search" id="search-task-options" placeholder="Qidirish: nomi yoki raqami (DTT...)"
                      v-model="search" />
                    <!-- Clear button -->
                    <button v-if="search" @click="search = ''" style="
                        position: absolute;
                        right: 8px;
                        top: 50%;
                        transform: translateY(-50%);
                        border: none;
                        background: transparent;
                        cursor: pointer;
                        font-size: 16px;
                      ">
                      ✖
                    </button>
                  </div>
                  
                  <!-- Kengaytirilgan Filtrlar Tugmasi -->
                  <button @click="showAdvancedFilters = true" class="advanced-filter-btn" title="Kengaytirilgan filtrlar">
                    <i class="fa fa-sliders"></i> Filtrlar
                    <span v-if="activeFilterCount > 0" class="filter-count-badge">{{ activeFilterCount }}</span>
                  </button>
                  
                </div>

                </div>

                <div style="position: absolute; bottom: -20px;">
                  <ul class="nav nav-tabs custom-tabs flex-nowrap" role="tablist" style="border: none;">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: viewMode === 'board' }" @click="viewMode = 'board'" href="javascript:void(0);">
                        <i class="fa-solid fa-chart-simple" style="color: #3C60D6;"></i> Board
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: viewMode === 'calendar' }" @click="viewMode = 'calendar'" href="javascript:void(0);">
                        <i class="fa-solid fa-calendar-days" style="color: #F76808;"></i> Calendar
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: viewMode === 'gantt' }" @click="viewMode = 'gantt'" href="javascript:void(0);">
                        <i class="fa-solid fa-chart-bar" style="color: #E5484D;"></i> Gantt
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: viewMode === 'table' }" @click="viewMode = 'table'" href="javascript:void(0);">
                        <i class="fa-solid fa-list" style="color: #30A46C;"></i> Table
                      </a>
                    </li>
                  </ul>
                </div>

              </div>
              <!--end col-->
              <div class="col-3">
                <div class="header-actions">

                  <!-- Bildirishnomalar -->
                  <a @click="invitesListDialog = true" class="header-action-item" title="Bildirishnomalar">
                    <i class="fa-regular fa-bell"></i>
                    <span v-if="allHelpRequests.filter(r => r.status === null).length > 0"
                      class="header-action-badge bg-danger">
                      {{ allHelpRequests.filter(r => r.status === null).length }}
                    </span>
                  </a>

                  <!-- Guruh tuzilmasi -->
                  <a @click="orgChartModel = true" class="header-action-item" title="Guruh tuzilmasi">
                    <i class="fa-solid fa-sitemap"></i>
                  </a>

                  <!-- Xodimlar statistikasi -->
                  <a @click="userStatisticsDialog = true" class="header-action-item" title="Xodimlar statistikasi">
                    <i class="fa-solid fa-chart-pie"></i>
                  </a>

                  <!-- Men yaratgan tasklar -->
                  <a @click="openTaskList(1)" class="header-action-item" data-bs-toggle="tooltip"
                    data-bs-trigger="hover" data-bs-placement="top" title="Yaratilgan topshiriqlar">
                    <i class="fas fa-plus-circle"></i>
                    <span v-if="createdTasksCount > 0" class="header-action-badge bg-danger">
                      {{ createdTasksCount }}
                    </span>
                  </a>

                  <!-- Menga kelib tushgan tasklar -->
                  <a @click="openTaskList(2)" class="header-action-item" data-bs-toggle="tooltip"
                    data-bs-trigger="hover" data-bs-placement="top" title="Ijroga tushgan topshiriqlar">
                    <i class="fa-solid fa-check-to-slot"></i>
                    <span v-if="incomingTasksCount > 0" class="header-action-badge bg-danger">
                      {{ incomingTasksCount }}
                    </span>
                  </a>

                  <!-- Menda ma'lumot uchun turgan tasklar -->
                  <a @click="openTaskList(3)" class="header-action-item" data-bs-toggle="tooltip"
                    data-bs-trigger="hover" data-bs-placement="top" title="Ma'lumot uchun topshiriqlar">
                    <i class="fas fa-info-circle"></i>
                    <span v-if="infoTasksCount > 0" class="header-action-badge bg-danger">
                      {{ infoTasksCount }}
                    </span>
                  </a>

                  <!-- Tugatilgan tasklar -->
                  <a @click="openTaskList(4)" class="header-action-item" data-bs-toggle="tooltip"
                    data-bs-trigger="hover" data-bs-placement="top" title="Arxiv topshiriqlar">
                    <i class="fa-solid fa-box-archive"></i>
                    <span v-if="finishedTasksCount > 0" class="header-action-badge bg-success">
                      {{ finishedTasksCount }}
                    </span>
                  </a>

                  <!-- Bekor qilingan tasklar -->
                  <a @click="openTaskList(5)" class="header-action-item is-danger" data-bs-toggle="tooltip"
                    data-bs-trigger="hover" data-bs-placement="top" title="Bekor qilingan topshiriqlar">
                    <i class="fas fa-file-circle-xmark"></i>
                    <span v-if="deletedTasksCount > 0" class="header-action-badge bg-danger">
                      {{ deletedTasksCount }}
                    </span>
                  </a>

                </div>
              </div>

              <div class="col-3" style="display: flex; align-items: center; gap: 25px;justify-content: end;">
                <div class="creative-avg">
                  <div 
                    v-for="mem in teamMems" :key="mem.id" 
                    @click="toggleAssigneeFilter(mem.id)" 
                    class="creative-avg-item" 
                    :class="{ 'active': advancedFilters.assignees.includes(mem.id) }"
                    :title="mem.name" 
                    data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top"
                  >
                    <img v-if="hasAvatar(mem.id)" :src="getEmployeeAvatar(mem.id)" alt="" class="creative-avg-img"/>
                    <div v-else class="creative-avg-initials">{{ getInitials(mem.name) }}</div>
                  </div>
                </div>
              </div>
              <!--end col-->
            </div>
            <!--end row-->
          </div>
          <!--end card-body-->
        </div>


        <!----------------------------------------- Task Views (Board, Calendar, List, Gantt) ----------------------------------------->

        <div class="board" v-show="viewMode === 'board'">
          <div class="columns">
            <section v-for="(col, cIdx) in columns" :key="col.id" class="column" :class="{ collapsed: col.collapsed }">
              <div class="column__head" :class="{ 'flex-column justify-content-center': col.collapsed }">
                <template v-if="col.editing">
                  <input v-model="col.title" class="input input--title form-control form-control-sm" @blur="col.editing = false"
                    @keyup.enter="col.editing = false" />
                </template>
                <template v-else>
                  <div class="d-flex w-100 overflow-hidden" :class="col.collapsed ? 'flex-column align-items-center justify-content-center' : 'align-items-center'">
                    <div v-if="col.id === 4 && !col.collapsed && filteredCards(col.cards || []).some(c => c.user_id == userId)" 
                         class="header-selection-check me-2" 
                         :class="{ 'checked': selectAllApproved }"
                         @click="toggleSelectAllApproved(col)"
                         title="Barchasini belgilash">
                      <i class="fa-solid fa-check"></i>
                    </div>
                    <h2 class="column__title fw-semibold mb-0" 
                        :class="{ 'text-truncate': !col.collapsed, 'mt-2': col.collapsed }"
                        :style="{ fontSize: '14px', color: '#495057', writingMode: col.collapsed ? 'vertical-lr' : 'horizontal-tb', transform: col.collapsed ? 'rotate(180deg)' : 'none' }">
                      {{ col.title }}
                    </h2>
                    <span class="badge rounded-pill shadow-none" 
                          :class="col.collapsed ? 'mb-2 mt-2' : 'ms-auto me-2'" 
                          style="background-color: rgba(64, 81, 137, 0.08); color: #405189; font-size: 11px; font-weight: 600; padding: 4px 8px;">
                      {{ filteredCards(col.cards || []).length || 0 }}
                    </span>
                    <button v-if="col.id === 4 && selectedApprovedTasks.length > 0 && !col.collapsed" 
                            @click="bulkAcceptTasks"
                            class="btn btn-sm btn-success p-0 me-2 d-flex align-items-center justify-content-center shadow-sm" 
                            style="width: 24px; height: 24px; border-radius: 6px;"
                            title="Tanlanganlarni qabul qilish">
                      <i class="fa-solid fa-check-double" style="font-size: 12px;"></i>
                    </button>
                    <button @click="shortColumn(cIdx)" 
                      class="btn btn-sm btn-icon border-0 shadow-none bg-transparent text-secondary p-0"
                      :style="{ width: '24px', height: '24px', flexShrink: 0, order: col.collapsed ? -1 : 10}">
                      <i class="fa-solid" :class="col.collapsed ? 'fa-angle-right' : 'fa-angle-left'" style="font-size: 14px;"></i>
                    </button>
                  </div>
                </template>
              </div>

              <div class="cards" :data-col="cIdx" :class="{
                'drag-target-column':
                  drag.overCol === cIdx &&
                  drag.overIndex === null &&
                  !filteredCards(col.cards || []).length,
              }" @dragover.prevent="onDragOverColumn(cIdx, $event)" @drop.prevent="onDropOnColumn(cIdx)">
                
                <!-- Skeleton Loader -->
                <template v-if="isTasksLoading">
                  <div v-for="n in 3" :key="'sk-' + cIdx + '-' + n" class="card-wrapper mb-2">
                    <article class="card p-3 shadow-sm border-0" style="border-radius: 8px;">
                      <div class="d-flex mb-3 align-items-center">
                        <div class="skeleton-box" style="width: 70%; height: 16px; border-radius: 4px;"></div>
                        <div class="skeleton-box ms-auto" style="width: 20%; height: 12px; border-radius: 4px;"></div>
                      </div>
                      <div class="mb-3">
                        <div class="skeleton-box" style="width: 100%; height: 6px; border-radius: 3px;"></div>
                        <div class="skeleton-box mt-2" style="width: 80%; height: 6px; border-radius: 3px;"></div>
                      </div>
                      <div class="d-flex justify-content-between align-items-center mt-2">
                        <div class="skeleton-box" style="width: 40%; height: 20px; border-radius: 10px;"></div>
                        <div class="d-flex gap-1">
                          <div class="skeleton-box rounded-circle" style="width: 24px; height: 24px;"></div>
                          <div class="skeleton-box rounded-circle" style="width: 24px; height: 24px;"></div>
                        </div>
                      </div>
                    </article>
                  </div>
                </template>

                <template v-else>
                  <div v-for="(card, i) in filteredCards(col.cards || []).filter((c) => c)" :key="card.id" class="card-wrapper">
                    <div class="insertion-line" :class="{active:drag.overCol === cIdx && drag.overIndex === i && drag.insertAbove,}" @dragover.prevent="onDragOverCard(cIdx, i, $event, true)"></div>
                  <article class="card" :class="{
                    'drag-source':
                      drag.fromCol === cIdx && drag.fromIndex === i,
                  }" :draggable="canDragTask(card)" @dragstart="onDragStart(cIdx, i, card)" @dragend="onDragEnd"
                    @dragover.prevent="onDragOverCard(cIdx, i, $event, false)" @drop="onDropOnCard(cIdx, i)">
                    <div class="card-body" @contextmenu.prevent="openContextMenu($event, card)">
                      <div v-if="col.id === 4 && card.user_id == userId" class="position-absolute card-selection-wrapper" 
                           :class="{ 'is-selected': selectedApprovedTasks.includes(card.id) }"
                           style="top: 10px; right: 10px; z-index: 5;">
                        <div class="custom-task-checkbox" 
                             :class="{ 'checked': selectedApprovedTasks.includes(card.id) }"
                             @click.stop="toggleTaskSelection(card.id)">
                          <i class="fa-solid fa-check"></i>
                        </div>
                      </div>
                      <span v-if="card.is_checked == true && card.column_id == 3" style="
                          left: 3% !important;" 
                          class="position-absolute top-0 translate-middle">
                           <img title="Tekshirildi" src="/assets/images/icons/verified.png" alt="image" style="width: 20px;height: 20px;cursor: pointer;">
                      </span>
                      <span v-if="card.unread_count > 0 && card.user_id == userId" style="
                          left: 97% !important;
                          border-radius: 50% !important;
                        " class="position-absolute top-0 translate-middle badge rounded-pill bg-danger">
                        {{ card.unread_count }}
                      </span>
                      <div v-for="member in card.members" :key="member.id">
                        <span v-if="
                          member.user_id == userId && member.unread_count > 0
                        " style="
                            left: 97% !important;
                            border-radius: 50% !important;
                          " class="position-absolute top-0 translate-middle badge rounded-pill bg-danger">{{
                            member.unread_count }}
                        </span>
                      </div>
                      <div class="d-flex mb-2">
                        <h6 class="fs-15 mb-0 flex-grow-1 text-truncate task-title">
                          <a @click="openTask(card)" class="d-block text-truncate mr-5" style="cursor: pointer">{{
                            card.text }}</a>
                        </h6>
                        <p style="margin: 0">{{ card.user_fullname }}</p>
                        <!-- <div class="dropdown">
                          <a href="javascript:void(0);" class="text-muted" :id="'dropdownMenuLink' + card.id"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="ri-more-fill"></i>
                          </a>
                          <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink' + card.id">
                            <li>
                              <a class="dropdown-item" href="#"><i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                View</a>
                            </li>
                            <li>
                              <a class="dropdown-item" href="#"><i
                                  class="ri-edit-2-line align-bottom me-2 text-muted"></i>
                                Edit</a>
                            </li>
                            <li>
                              <a class="dropdown-item" href="#" @click.prevent="removeTask(cIdx, i)"><i
                                  class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i>
                                Delete</a>
                            </li>
                          </ul>
                        </div> -->
                      </div>
                      <!-- <p class="text-muted multi-line-truncate">{{ card.description || 'No description available' }}</p> -->
                      <div class="mb-2">
                        <!-- Task kichikroq korinishi uchun commentga olindi -->

                        <!-- <div class="d-flex mb-1">
                    <div class="flex-grow-1">
                      <h6 class="text-muted mb-0">Muddati:</h6>
                    </div>
                    <div class="flex-shrink-0">
                      <span class="text-muted">
                        {{ card?.deadline ? new Date(card.deadline).toLocaleDateString('en-GB') : 'No deadline' }}
                      </span>
                    </div>
                  </div> -->

                        <!-- Task kichikroq korinishi uchun commentga olindi -->

                        <div class="progress rounded-3 progress-sm">
                          <div class="progress-bar" role="progressbar" :class="getDeadlineProgressColor(card)"
                            :style="{ width: getRemainingProgress(card) + '%' }"
                            :aria-valuenow="getRemainingProgress(card)" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1" style="display: flex; align-items: center">
                          <div v-for="process in card.members || []" :key="process?.id">
                            <span v-if="process.user_id == userId" class="badge bg-primary-subtle text-primary me-1">
                              {{
                                process.process === "Rozilik"
                                  ? "Nazorat/Rozilik uchun"
                                  : process.process + " uchun"
                              }}
                            </span>
                          </div>
                          <div v-if="card.user_id == userId">
                            <span class="badge bg-primary-subtle text-primary me-1">
                              Yaratildi
                            </span>
                          </div>
                          <span>
                            {{ card.created_at ? new Date(card.created_at).toLocaleDateString(
                                  "en-GB",
                                  {
                                    year: "2-digit",
                                    month: "2-digit",
                                    day: "2-digit",
                                  }
                                )
                                : "Undefined"
                            }}
                          </span>

                          <span v-if="card.column_id == 1 || card.column_id == 2" style="font-size: 10px"
                            class="position-absolute deadline-days badge rounded-pill" :class="{
                              'bg-danger': getDaysLeft(card) < 0,
                              'bg-warning': getDaysLeft(card) === 0,
                              'bg-success': getDaysLeft(card) > 0,
                            }">
                            {{
                              getDaysLeft(card) < 0 ? "Muddati o‘tgan: " + Math.abs(getDaysLeft(card)) + " kun" :
                                getDaysLeft(card) === 0 ? "Muddati: Bugun" : "Muddati: " + getDaysLeft(card) + " kun" }}
                              </span>
                        </div>

                        <div class="flex-shrink-0">
                          <div class="avatar-group">
                            <a v-for="member in card.members" :key="member.user_id" href="javascript: void(0);"
                              class="avatar-group-item material-shadow" :data-bs-toggle="'tooltip'"
                              data-bs-trigger="hover" data-bs-placement="top" :title="`${member.full_name} - ` + getEmployeeNameWithProcess(
                                member.user_id,
                                card.members
                              )
                                ">
                              <img :src="`https://api.task-board.uz/storage/user/avatar/${member?.avatar || 'user.png'}`" alt="" class="rounded-circle avatar-xxs" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <!-- File Attachment Chip -->
                      <div v-if="card.file_path || (card.files && card.files.length > 0)" class="mt-2 mb-1">
                        <div class="task-file-chip" @click.stop="getTaskFile(card.file_path || (card.files && card.files.length > 0 ? (typeof card.files[0] === 'string' ? card.files[0] : (card.files[0].path || card.files[0].file_path || card.files[0].url)) : ''), card.file_name || (card.files && card.files.length > 0 ? (typeof card.files[0] === 'string' ? card.files[0].split('/').pop() : (card.files[0].name || card.files[0].file_name || card.files[0].original_name)) : ''))">
                          <div class="file-icon-bg">
                            <i class="fa-solid fa-paperclip"></i>
                          </div>
                          <div class="file-chip-info">
                            <span class="file-chip-name text-truncate" :title="card.file_name || (card.files && card.files.length > 0 ? (typeof card.files[0] === 'string' ? card.files[0].split('/').pop() : (card.files[0].name || card.files[0].file_name || card.files[0].original_name)) : '')">{{ card.file_name || (card.files && card.files.length > 0 ? (typeof card.files[0] === 'string' ? card.files[0].split('/').pop() : (card.files[0].name || card.files[0].file_name || card.files[0].original_name)) : 'Ilova qilingan fayl') }}</span>
                            <span v-if="card.files && card.files.length > 1" class="file-chip-count">+{{ card.files.length - 1 }}</span>
                          </div>
                          <i class="fa-solid fa-download download-icon"></i>
                        </div>
                      </div>

                      <!-- Subtasklar paneli (har bir task uchun alohida holat) -->
                      <div v-if="(card.subtasks.length > 0) || card.subtaskForm">
                        <div 
                          class="subtask-actions"
                          :class="{ active: card.isSubtasksOpen }"
                          @click="toggleSubtasks(card)"
                        >
                          <div class="icon-container">
                            <i class="fa-solid fa-link link-icon"></i>
                            <i class="fa-solid fa-caret-right right-icon"></i>
                            <i class="fa-solid fa-caret-down down-icon"></i>
                          </div>

                          <span class="label">
                            <strong>{{ card.subtasks.length }}</strong> Subtask
                          </span>

                          <!-- <button 
                            class="add-btn"
                            @click.stop="addNewSubtask(card)"
                          >
                            + Add
                          </button> -->
                        </div>

                        <!-- Kengaygan subtasklar qismi -->
                        <div v-if="card.isSubtasksOpen" class="subtask-content">
                          <!--  New subtask form -->
                          <div class="subtask-form mb-2" v-if="card.subtaskForm">

                            <!-- Subtask name -->
                            <input v-model="subTaskName" type="text" class="subtask-input mb-2" ref="subtaskInputs"
                              placeholder="Subtask Name..." />

                            <!-- Subtask description -->
                            <textarea v-model="subTaskDescription" class="subtask-input" style="width: 100%;" placeholder="Description"></textarea>

                            <div class="subtask-options">
                              <!-- Member qo'shish uchun -->
                              <button class="option-btn" @click="openModal($event, 'assignee')">
                                <span>
                                  <i class="fa-regular fa-circle-user"></i> Add assignee
                                </span>
                                <div class="assignee-avatars-only" v-if="selectedMembers?.length">
                                  <img 
                                    v-for="(member, i) in selectedMembers.slice(-5)" 
                                    :key="member.user_id"
                                    :src="getEmployeeAvatar(member.user_id)"
                                    class="assignee-avatar-sm"
                                    :style="{ marginLeft: i === 0 ? 0 : '-10px', zIndex: selectedMembers.length - i }"
                                    :title="getEmployeeName(member.user_id)"
                                    @error="$event.target.src = 'https://ui-avatars.com/api/?background=64748b&color=fff&name=' + getEmployeeName(member.user_id)"
                                  />

                                  <!-- Agar 5 tadan ko‘p bo‘lsa +N -->
                                  <span 
                                    v-if="selectedMembers.length > 5" 
                                    class="assignee-more-sm"
                                    :style="{ marginLeft: '-10px', zIndex: 1 }"
                                  >+{{ selectedMembers.length - 5 }}</span>
                                </div>
                              </button>

                              <!-- Muddatini belgilash uchun -->
                              <button class="option-btn" @click="openModal($event, 'date')">
                                <span><i class="fa-regular fa-calendar-days"></i> Add dates</span>
                                <span>{{ dateText }}</span>
                              </button>

                            </div>

                            <!-- Modal -->
                             
                            <!-- Memberlarni kiritish form -->
                            <div v-if="showModal" class="option-modal"
                              :style="{ top: modalY + 'px', left: modalX + 'px' }">
                              <div class="modal-header">
                                <strong>{{ modalType === 'assignee' ? 'Assignee' :
                                  modalType === 'date' ? 'Due Date' :
                                    'Priority' }}</strong>
                                <button @click="showModal = false" class="close-btn">×</button>
                              </div>

                              <!-- Assignee -->
                              <div v-if="modalType === 'assignee'" class="subtask-assignee-section">
                                <div class="subtask-assignee-header">
                                  <span>Kengroq qidiruv</span>
                                  
                                    <input 
                                      type="checkbox" 
                                      v-model="isWideSearch" 
                                      class="subtask-checkbox"
                                    />
                                </div>

                                <div class="subtask-assignee-form">
                                  <v-autocomplete
                                    v-model="newMember.user_id"
                                    :items="availableEmployees"
                                    :disabled="isUpdating"
                                    color="primary"
                                    item-title="name"
                                    item-value="id"
                                    label="Xodimni tanlang"
                                    prepend-inner-icon="mdi-account-search"
                                    variant="outlined"
                                    density="compact"
                                    hide-details="auto"
                                    class="subtask-assignee-autocomplete"
                                    autocomplete="off"
                                  >
                                    <!-- Tanlangan chip -->
                                    <template v-slot:selection="{ item, attrs }">
                                      <v-chip
                                        v-bind="attrs"
                                        :prepend-avatar="item.raw.avatar"
                                        size="small"
                                        label
                                        class="subtask-selected-chip"
                                      >
                                        {{ item.raw.name }}
                                      </v-chip>
                                    </template>

                                    <!-- Dropdown item -->
                                    <template v-slot:item="{ props, item }">
                                      <v-list-item
                                        v-bind="props"
                                        :prepend-avatar="item.raw.avatar"
                                        :subtitle="item.raw.group || 'Guruh yo‘q'"
                                        :title="item.raw.name"
                                        density="compact"
                                      ></v-list-item>
                                    </template>
                                  </v-autocomplete>

                                  <v-select
                                    v-model="newMember.process"
                                    :items="availableProcesses"
                                    label="Jarayon"
                                    :disabled="!newMember.user_id"
                                    variant="outlined"
                                    density="compact"
                                    hide-details="auto"
                                    class="subtask-process-select"
                                  ></v-select>

                                  <v-btn
                                    color="primary"
                                    size="small"
                                    :disabled="!newMember.user_id || !newMember.process"
                                    @click="addMember"
                                    class="subtask-add-btn"
                                  >
                                    Qo‘shish
                                  </v-btn>
                                </div>

                                <!-- Tanlangan xodimlar ro‘yxati -->
                                <div class="subtask-selected-members" v-if="selectedMembers.length">
                                  <div class="subtask-selected-title">Tanlangan xodimlar</div>
                                  
                                  <div class="subtask-member-list">
                                    <div 
                                      v-for="(member, index) in selectedMembers" 
                                      :key="index"
                                      class="subtask-member-item"
                                    >
                                      <img 
                                        :src="getEmployeeAvatar(member.user_id)" 
                                        alt="avatar" 
                                        class="subtask-member-avatar"
                                        @error="handleAvatarError"
                                      />
                                      
                                      <div class="subtask-member-info">
                                        <span class="subtask-member-name">
                                          {{ getEmployeeName(member.user_id) }}
                                        </span>
                                        <span class="subtask-member-process">
                                          {{ member.process }}
                                        </span>
                                      </div>

                                      <v-btn
                                        icon
                                        size="x-small"
                                        color="error"
                                        variant="text"
                                        @click="removeMember(index)"
                                        class="subtask-remove-btn"
                                      >
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                    </div>
                                  </div>
                                </div>

                                <div v-else class="subtask-no-members">
                                  Hozircha xodim qo‘shilmagan
                                </div>
                              </div>

                              <!-- Subtask deadlinelar kiritish form -->
                              <div v-if="modalType === 'date'">
                                <div class="card flex justify-center">
                                  <v-date-input
                                    v-model="subTaskDate"
                                    multiple="range"
                                    density="compact"
                                    variant="outlined"
                                    hide-details
                                    prepend-icon=""                 
                                    prepend-inner-icon="mdi-calendar-range"
                                    clearable
                                    autocomplete="off"
                                  />
                                </div>
                              </div>
                            </div>

                            <!-- Submit qilish uchun btn -->
                            <div class="save-area">
                              <button class="save-btn" @click="saveSubtask(card)">Save</button>
                              <button class="close-btn" @click="card.subtaskForm = false"><i
                                  class="fa-solid fa-xmark"></i></button>
                            </div>
                          </div>
                          <!-- Subtasklar ro'yxati -->
                          <div v-if="card.subtasks.length > 0" class="subtask-list">
                            <div v-for="(subtask, subIndex) in card.subtasks" :key="subIndex" class="subtask-compact-item" @click.stop="openTask(card)">
                              
                              <div class="subtask-role-badge" v-if="subtask.assignees?.some(a => a.user_id === userId)">
                                <span class="role-assignee">{{ subtask.assignees?.find(a => a.user_id === userId)?.process }}</span>
                              </div>

                              <div class="subtask-compact-left">
                                <i class="fa-regular fa-square-check mt-1" style="font-size: 15px; color: #3b82f6;"></i>
                                <div class="subtask-compact-info">
                                  <div class="subtask-compact-title">
                                    <span class="subtask-id">#{{ subtask.id || 'N/A' }}</span>
                                    {{ subtask.name }}
                                  </div>
                                  <div class="subtask-compact-desc" v-if="subtask.description">
                                    {{ subtask.description }}
                                  </div>
                                  <div class="subtask-compact-badges">
                                    <span v-if="subtask.status === 'new' || !subtask.status" class="compact-badge in-progress">Jarayonda</span>
                                    <span v-else-if="subtask.status === 'Bajarildi' || subtask.done" class="compact-badge done">Bajarildi</span>
                                    <span v-else class="compact-badge in-progress">{{ subtask.status }}</span>

                                    <span v-if="subtask.deadline" class="compact-badge date"><i class="fa-regular fa-clock"></i> {{ subtask.deadline }}</span>
                                  </div>
                                </div>
                              </div>
                              
                              <div class="subtask-compact-right">
                                <div class="subtask-compact-users" v-if="subtask.assignees?.length">
                                  <img v-for="(member, i) in subtask.assignees.slice(0,3)" :key="member.id"
                                       :src="`https://api.task-board.uz/storage/user/avatar/${member?.avatar || 'user.png'}`" 
                                       class="compact-avatar" 
                                       :title="`${getEmployeeName(member.user_id)} (${member.process})`" 
                                       :style="{ zIndex: subtask.assignees.length - i }" />
                                  <span v-if="subtask.assignees.length > 3" class="compact-avatar-more" style="z-index: 0;">+{{ subtask.assignees.length - 3 }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <teleport to="body">
                        <transition name="slide-up" v-if="
                          (card.column_id === 1 || card.column_id === 2) &&
                          card.user_id == userId
                        ">
                          <div v-if="
                            contextMenu.visible &&
                            contextMenu.cardId === card.id
                          " @click.self="contextMenu.visible = false" class="custom-context-menu" :style="{
                            top: contextMenu.y + 'px',
                            left: contextMenu.x + 'px',
                          }">
                            <ul>
                              <li v-if="(card.column_id == 1)" @click="editTask(card)">
                                <i class="fa-solid fa-pencil" style="color: #146ebe"></i>
                                Edit
                              </li>
                              <li v-if="(card.column_id == 1)" @click="deleteTask(card.id)">
                                <i class="fa-solid fa-trash" style="color: #146ebe"></i>
                                Delete
                              </li>
                              <li @click="copyTask(card)">
                                <i class="fa-solid fa-copy" style="color: #146ebe"></i>
                                Copy
                              </li>
                              <li v-if="isCreateTaskDisabled" @click="subtaskForm(card)">
                                <i class="fa-solid fa-diagram-predecessor" style="color: #146ebe"></i>
                                Add Subtask
                              </li>
                            </ul>
                          </div>
                        </transition>
                      </teleport>
                    </div>
                  </article>
                  <div v-if="i === filteredCards(col.cards || []).length - 1" class="insertion-line" :class="{
                    active:
                      drag.overCol === cIdx &&
                      drag.overIndex === i + 1 &&
                      !drag.insertAbove,
                  }" @dragover.prevent="
                    onDragOverCard(cIdx, i + 1, $event, false)
                    "></div>
                </div>
                </template>
                <div v-if="!isTasksLoading && !filteredCards(col.cards).length" class="empty">
                  Vazifa yo'q
                </div>
              </div>
            </section>
          </div>
        </div>

        <!-- Custom Gantt Chart -->
        <CustomGantt
          v-if="viewMode === 'gantt'"
          :tasks="filteredRawTasks || []"
          :userId="userId"
          :avatarResolver="getEmployeeAvatar"
          @update-task-dates="updateTaskDates"
          @task-click="openTask"
        />
        <div class="calendar-container" v-if="viewMode === 'calendar'">
          <FullCalendar :options="calendarOptions" />
        </div>

        <div class="performance-table" v-show="viewMode === 'table'">
          <div class="toolbar">
            <button @click="exportCsv">📁 CSV eksport</button>
            <button @click="clearFilters">🧹 Filterlarni tozalash</button>
            <button @click="deleteSelected">🗑️ Tanlanganlarni o'chirish</button>
            <input v-model="quickFilterText" @input="onQuickFilter" placeholder="Tez qidiruv..." />
          </div>
      
          <ag-grid-vue
            class="ag-theme-alpine"
            :theme="'legacy'"
            style="width: 100%; height: 75vh;"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :defaultColDef="defaultColDef"
            :rowSelection="'multiple'"
            :animateRows="true"
            :rowDragManaged="true"
            :rowMultiSelectWithClick="true"
            :pagination="true"
            :paginationPageSize="15"
            :enableCellTextSelection="true"
            :suppressRowClickSelection="false"
            :suppressMovableColumns="false"
            @grid-ready="onGridReady"
          />
        </div>

        <!----------------------------------------- Task Views (Board, Calendar, List, Gantt) ----------------------------------------->



        <!-- Dialogs -->



        <!-- Topshiriqni boshqa xodimga yo‘naltirish uchun dialog -->
        <v-dialog v-model="redirectToEmployeeDialog" max-width="500px" persistent z-index="999">
          <!-- Dialog Card -->
          <v-card class="pa-4" rounded="lg" elevation="4">
            <!-- Dialog Title -->
            <v-card-title class="text-h6 font-weight-bold primary--text">
              Topshiriqni yo‘naltirish uchun xodim tanlang
            </v-card-title>

            <!-- Dialog Content -->
            <v-card-text>
              <v-autocomplete v-model="redirectToEmployeeId" :items="myEmployees" item-title="name" item-value="id"
                label="Xodimni tanlang" variant="outlined" density="compact" clearable
                prepend-inner-icon="mdi-account-search" hide-details="auto" class="mt-2">
                <!-- Custom item slot for better display -->
                <!-- <template v-slot:item="{ item, props }">
            <v-list-item
              v-bind="props"
              :title="item.name"
              :subtitle="item.email || 'No email provided'"
              prepend-icon="mdi-account"
              class="py-2"
            ></v-list-item>
          </template> -->
              </v-autocomplete>
            </v-card-text>

            <!-- Dialog Actions -->
            <v-card-actions class="justify-end gap-3 px-4 pb-3">
              <v-btn variant="text" color="grey darken-2"
                class="rounded-lg px-5 font-medium text-capitalize hover:bg-grey lighten-4 transition-all"
                @click="redirectToEmployeeDialog = false">
                Qaytish
              </v-btn>

              <v-btn variant="flat" color="primary"
                class="rounded-lg px-6 font-semibold text-white shadow-sm hover:shadow-md hover:opacity-90 transition-all"
                @click="handleConfirm" :disabled="!redirectToEmployeeId">
                Yuborish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Topshiriqni boshqa xodimga yo‘naltirish uchun dialog end -->



        <!-- Fayldan topshiriqlarni yuklash uchun dialog -->
        <v-dialog v-model="fileDialog" max-width="600px">
          <v-card class="pa-6" style="border-radius: 12px">
            <v-card-title class="text-h5 font-weight-bold d-flex justify-space-between align-center">
              <span>Fayldan yuklash</span>
              <v-btn icon @click="fileDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <div style="
                padding-left: 16px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
              ">
              <i class="fa-solid fa-circle-info" style="color: #146ebe; font-size: 20px"></i>
              <p style="margin: 0 10px">
                Topshiriqlarni fayldan yuklash uchun:
              </p>
              <a href="assets\files\Namuna.xlsx" download style="text-decoration: underline">Namuna fayl</a>
            </div>
            <v-card-text>
              <v-file-input v-model="excelFile" label="Namuna faylni to‘ldirib yuklang" outlined
                prepend-icon="mdi-paperclip" accept="*" show-size hint="Faylni bu yerga yuklang" persistent-hint
                class="mt-4" @change="handleExcelFile"></v-file-input>
            </v-card-text>

            <v-card-actions class="d-flex justify-end">
              <v-btn color="grey lighten-2" text @click="fileDialog = false">
                Bekor qilish
              </v-btn>
              <v-btn color="primary" depressed @click="uploadExcel" :disabled="!excelFile">
                Yuklash
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Fayldan topshiriqlarni yuklash uchun dialog end -->



        <!-- Shablonlarni boshqarish moduli -->
        <TemplateManagerModal
          v-model="templateManagerDialog"
          @updated="fetchTaskTemplates"
        />

        <!-- Yangi topshiriq yaratish dialog va Tahrirlash Dialoglari -->
        <TaskFormModal
          v-model="createTaskDialog"
          :is-edit="false"
          :template-data="selectedTemplateData"
          :my-employees="myEmployees"
          :employees="employees"
          :processes="processes"
          v-model:isWideSearchModel="isWideSearch"
          :column-id="columns[0]?.id || 1"
          @update:templateData="val => selectedTemplateData = val"
          @success="fetchTasks"
          @open-file-dialog="fileDialog = true"
        />

        <!-- Faqat o'zi uchun topshiriq yaratish -->
        <TaskFormModal
          v-model="selfTaskDialog"
          :is-edit="false"
          :self-mode="true"
          :my-employees="myEmployees"
          :employees="employees"
          :processes="processes"
          v-model:isWideSearchModel="isWideSearch"
          :column-id="columns[0]?.id || 1"
          @success="fetchTasks"
        />

        <TaskFormModal
          v-model="editTaskDialog"
          :is-edit="true"
          :task-data="selectedTaskForEdit"
          :my-employees="myEmployees"
          :employees="employees"
          :processes="processes"
          v-model:isWideSearchModel="isWideSearch"
          @success="fetchTasks"
          @open-file-dialog="fileDialog = true"
        />
        <!-- Dialoglar tugadi -->

        <!-- taskModal (yangi) — TaskDialog component -->

        <v-dialog
          v-model="taskModal"
          style="min-width: 1000px !important"
          persistent
        >
          <div
            class="modal-dialog modal-dialog-centered"
          >
            <div class="modal-content border-0">

              <!-- BODY: BIZNING YANGI COMPONENT -->
              <div v-if="selectedTask">
                <TaskDialog
                    v-if="selectedTask"
                    v-model:isWideSearch="isWideSearch"
                    :task="selectedTask"
                    :can-move-back="canMoveBack"
                    :can-move-next="canMoveNext"
                    :get-employee-avatar="getEmployeeAvatar"
                    :get-employee-name="getEmployeeName"
                    :my-employees="myEmployees"
                    :employees="employees"
                    :processes="processes"
                    @close="taskModal = false, markCommentsAsRead(selectedTask.id)"
                    @comment-added="incrementCommentCount"
                    @update-column="({ id, column_id }) => updateTaskColumn(id, column_id)"
                    @redirect="redirectToEmployee"
                    @copy-task="copyTask"
                    @edit-task="editTask"
                    @delete-task="deleteTask"
                    @get-help="getHelp"
                    @accept-task="finishTask"
                  />
              </div>
            </div>
          </div>
        </v-dialog>


        <v-dialog
          v-model="orgChartModel"
          style="min-width: 1000px !important"
          persistent>
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0">
              <OrgChartComponent 
                @close-modal="closeOrgChart"
              />
            </div>
          </div>
        </v-dialog>

        <!-- Xodimlar bo‘yicha statistika oynasi -->
        <UserStatisticsModal
          v-model="userStatisticsDialog"
          :workspace-id="activeWorkspaceId"
          :workspace-name="selectedWorkspaceName"
        />

        <!-- Task tafsilotlarini ko‘rsatish uchun dialog end-->

        <!-- Tasklar ro‘yxatini ko‘rsatish uchun dialog -->
        <v-dialog v-model="openTaskListDialog" max-width="850px">
          <div class="modern-modal">
            <div class="modern-modal-header border-bottom pa-4 d-flex justify-space-between align-center" style="background: #ffffff; border-radius: 12px 12px 0 0;">
              <div class="modern-modal-title mb-0 d-flex align-center">
                <div class="modern-modal-icon me-3" style="background: linear-gradient(135deg, #3b82f6, #6366f1); border-radius: 8px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; color: white;">
                  <i class="fa-solid fa-list-check" style="font-size: 18px;"></i>
                </div>
                <div>
                  <h3 style="font-size: 20px; font-weight: 700; color: #1e293b; margin: 0;">{{ taskListName }}</h3>
                  <p style="font-size: 13px; color: #64748b; margin: 0;">{{ filteredTasksByTypeId ? filteredTasksByTypeId.length : 0 }} ta topshiriq</p>
                </div>
              </div>
              <v-btn icon="mdi-close" variant="text" size="small" @click="openTaskListDialog = false" class="modern-close-btn"></v-btn>
            </div>
            
            <div class="modern-modal-body" style="background: #f8fafc; padding: 20px; max-height: 75vh; overflow-y: auto;">
              <div v-if="filteredTasksByTypeId && filteredTasksByTypeId.length > 0" class="premium-task-grid">
                <div v-for="card in filteredTasksByTypeId" :key="card.id" class="premium-task-card" :style="{ borderTopColor: getPremiumStatusColor(card.status), borderTopWidth: '4px' }" @click="openTask(card)">
                  
                  <div class="card-header-part d-flex justify-content-between align-items-start mb-2">
                     <div class="d-flex flex-column">
                        <span class="task-card-id mb-1">#{{ card.id }}</span>
                        <h5 class="task-card-title text-truncate mb-0" :title="card.text || card.task_name" style="max-width: 200px;">{{ card.text || card.task_name || "Nomsiz topshiriq" }}</h5>
                     </div>
                     <span class="badge premium-badge" :style="{ color: getPremiumStatusColor(card.status), backgroundColor: getPremiumStatusBgColor(card.status) }">{{ card.status || "Noma'lum" }}</span>
                  </div>
                  
                  <p class="task-card-desc mb-3">{{ card.task_description || "Topshiriq tavsifi mavjud emas" }}</p>
                  
                  <div class="mt-auto pt-3 border-top d-flex align-items-end justify-content-between">
                     <div class="d-flex flex-column gap-2">
                        <div class="task-card-meta" title="Yaratuvchi">
                          <i class="fa-regular fa-user" style="color: #8b5cf6;"></i> <span class="text-truncate" style="max-width: 140px;">{{ card.user_fullname || 'Noma\'lum xodim' }}</span>
                        </div>
                        <div class="task-card-meta" title="Bajarish muddati">
                          <i class="fa-regular fa-calendar" style="color: #f59e0b;"></i> <span :class="{'text-danger fw-semibold': isDeadlinePassed && isDeadlinePassed(card.task_deadline || card.deadline)}">{{ (card.task_deadline || card.deadline) ? new Date(card.task_deadline || card.deadline).toLocaleDateString('en-GB') : "Muddat yo'q" }}</span>
                        </div>
                        <div v-if="card.file_path || (card.files && card.files.length > 0)" class="task-card-meta text-primary" title="Ilova qilingan fayllar">
                          <i class="fa-solid fa-paperclip" style="color: #06b6d4;"></i> <span class="fw-medium">{{ card.files?.length || 1 }} ta fayl</span>
                        </div>
                     </div>

                     <!-- Avatars -->
                     <div class="avatar-group">
                       <a v-for="member in (card.task_members || card.members)" :key="member.user_id || member.id" href="javascript: void(0);"
                         class="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top"
                         :title="`${member.full_name} - ` + getEmployeeNameWithProcess(
                                member.user_id,
                                card.members
                              )">
                         <img :src="`https://api.task-board.uz/storage/user/avatar/${member?.avatar || 'user.png'}`" alt="" class="rounded-circle avatar-xxs premium-avatar" />
                       </a>
                     </div>
                  </div>
                </div>
              </div>
              <div v-else class="text-center p-5">
                <div style="font-size: 45px; color: #cbd5e1; margin-bottom: 15px;">
                  <i class="fa-regular fa-folder-open"></i>
                </div>
                <h5 style="color: #64748b; font-weight: 600;">Topshiriqlar topilmadi</h5>
                <p style="color: #94a3b8; font-size: 14px;">Ushbu bo'limda hozircha vazifalar mavjud emas.</p>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- Tasklar ro‘yxatini ko‘rsatish uchun dialog end-->



        <!-- Topshiriq uchun yordam so‘rash dialogi -->
        <v-dialog
          v-model="getHelpDialog"
          max-width="500"
          persistent
        >
          <!-- Dialog Content -->
          <v-card>
            <v-card-title class="d-flex align-center justify-space-between">
              <span class="text-h6">Xabar yuborish</span>
              <v-btn
                icon
                variant="text"
                @click="getHelpDialog = false, selectedMembers = []"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <form @submit.prevent="sendHelpRequest">
                <!-- User Autocomplete -->
                <v-autocomplete
                  v-model="selectedHelpUser"
                  :items="availableEmployeesForHelp"
                  item-title="name"
                  item-value="id"
                  label="Xodimni tanlang"
                  placeholder="Xodimni qidirish..."
                  prepend-inner-icon="mdi-account-search"
                  variant="outlined"
                  density="comfortable"
                  clearable
                  :rules="[v => !!v || 'Xodimni tanlash shart']"
                  required
                >
                  <template v-slot:chip="{ props, item }">
                    <v-chip
                      v-bind="props"
                      :prepend-avatar="getEmployeeAvatar(item.raw.id)"
                      :text="item.raw.name"
                    ></v-chip>
                  </template>

                  <!-- Dropdownda chiqadigan elementlar -->
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      :prepend-avatar="getEmployeeAvatar(item.raw.id)"
                      :subtitle="item.raw.group"
                      :title="item.raw.name"
                    ></v-list-item>
                  </template>
                </v-autocomplete>

                <!-- Message Input -->
                <v-textarea
                  v-model="helpMessage"
                  label="Xabar matni"
                  placeholder="Xabaringizni yozing..."
                  prepend-inner-icon="mdi-message-text"
                  variant="outlined"
                  rows="4"
                  auto-grow
                  :rules="[v => !!v || 'Xabar matni kiritish shart']"
                  class="mb-4"
                ></v-textarea>
              </form>
            </v-card-text>

            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                variant="tonal"
                @click="getHelpDialog = false, selectedMembers = []"
              >
                Bekor qilish
              </v-btn>
              <v-btn
                color="primary"
                @click="sendHelpRequest"
              >
                Yuborish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Topshiriq uchun yordam so‘rash dialogi end-->



        <!-- Takliflar ro‘yxatini ko‘rsatish uchun dialog -->
        <v-dialog v-model="invitesListDialog" max-width="600px" persistent>

          <div class="bg-pattern rounded" style="min-height: 500px;">
            <!-- Header -->
            <div class="p-3 bg-primary rounded-top">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0 fs-16 fw-semibold text-white">Notifications</h6>
                </div>

                <div class="col-auto">
                  <span class="badge bg-light-subtle text-body fs-13">
                    {{ allHelpRequests.length }} New
                  </span>
                </div>

                <div class="col-auto" @click="invitesListDialog = false">
                  <i class="fa fa-xmark" style="cursor: pointer"></i>
                </div>
              </div>
            </div>

            <!-- Tabs -->
            <div class="px-2 pt-2">
              <ul class="nav nav-tabs dropdown-tabs nav-tabs-custom">
                <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" href="#all">
                    All ({{ allHelpRequests.length }})
                  </a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#outbox">
                    Outbox ({{ myHelpRequests.length }})
                  </a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#inbox">
                    Inbox ({{ incomingHelpRequests.length }})
                  </a>
                </li>
              </ul>
            </div>

            <!-- Content -->
            <div class="tab-content" style="max-height: 400px">

              <!-- ALL -->
              <div id="all" class="tab-pane fade show active py-2 ps-2">
                <div data-simplebar class="pe-2" style="max-height:400px;background:white">
                  <HelpRequestItem
                    v-for="req in allHelpRequests"
                    :key="req.id"
                    :item="req"
                    :userId="userId"
                    @accept="acceptRequest"
                    @reject="rejectRequest"
                    @open-task="openTask"
                  />
                </div>
              </div>

              <!-- OUTBOX -->
              <div id="outbox" class="tab-pane fade py-2 ps-2">
                <div data-simplebar class="pe-2" style="max-height:400px;background:white">
                  <HelpRequestItem
                    v-for="req in myHelpRequests"
                    :key="req.id"
                    :item="req"
                    :userId="userId"
                    @accept="acceptRequest"
                    @reject="rejectRequest"
                    @open-task="openTask"
                  />
                </div>
              </div>

              <!-- INBOX -->
              <div id="inbox" class="tab-pane fade py-2 ps-2">
                <div data-simplebar class="pe-2" style="max-height:400px;background:white">
                  <HelpRequestItem
                    v-for="req in incomingHelpRequests"
                    :key="req.id"
                    :item="req"
                    :userId="userId"
                    @accept="acceptRequest"
                    @reject="rejectRequest"
                    @open-task="openTask"
                  />
                </div>
              </div>

            </div>
          </div>

        </v-dialog>

        <!-- Takliflar ro‘yxatini ko‘rsatish uchun dialog end-->


        
      
        <!-- End Dialogs -->
      </div>
    </div>
    <!-- container-fluid -->
  </div>
    <!-- ADVANCED FILTERS MODAL (SOFT UI) -->
    <div v-if="showAdvancedFilters" class="pdf-modal advanced-filter-overlay" @click.self="showAdvancedFilters = false">
      <div class="advanced-filter-dialog">
        <div class="afd-header">
           <h4 class="afd-title"><i class="fa fa-filter text-primary"></i> Kengaytirilgan filtrlash</h4>
           <button @click="showAdvancedFilters = false" class="afd-close"><i class="fa fa-times"></i></button>
        </div>
        <div class="afd-body">
           <!-- Faol Filtrlar Belgilari Yozuvi -->
           <div v-if="activeFilterCount > 0" class="active-filters-ribbon mb-4 mt-0">
               <span v-for="(lbl, idx) in activeFilterLabels" :key="idx" class="afr-chip">
                   {{ lbl.text }}
                   <i class="fa fa-times ms-1" style="cursor: pointer;" @click="removeAdvancedFilter(lbl.type)"></i>
               </span>
               <a href="javascript:void(0)" class="afr-clear text-danger" @click="clearAllAdvancedFilters()">Barchasini tozalash</a>
           </div>

           <div class="afd-row">
              <label>Ijrochi xodimlar</label>
              <v-autocomplete
                v-model="advancedFilters.assignees"
                :items="employees"
                item-title="name"
                item-value="id"
                multiple
                chips
                closable-chips
                variant="outlined"
                density="compact"
                hide-details
                placeholder="Tanlash..."
                autocomplete="off"
              ></v-autocomplete>
           </div>
           
           <div class="afd-row mt-3">
              <label>Vazifa mualliflari</label>
              <v-autocomplete
                v-model="advancedFilters.creators"
                :items="employees"
                item-title="name"
                item-value="id"
                multiple
                chips
                closable-chips
                variant="outlined"
                density="compact"
                hide-details
                placeholder="Tanlash..."
                autocomplete="off"
              ></v-autocomplete>
           </div>

           <div class="afd-row mt-3">
              <label>Topshiriq Holati (Status)</label>
              <v-autocomplete
                v-model="advancedFilters.statuses"
                :items="columns"
                item-title="title"
                item-value="id"
                multiple
                chips
                closable-chips
                variant="outlined"
                density="compact"
                hide-details
                placeholder="Tanlash..."
                autocomplete="off"
              ></v-autocomplete>
           </div>
           
           <div class="afd-row mt-3 ml-2">
              <v-switch
                v-model="advancedFilters.onlyOverdue"
                label="Muddati o'tgan topshiriqlar"
                color="error"
                hide-details
                density="compact"
              ></v-switch>
           </div>
           
           <div class="afd-row mt-3 d-flex gap-3">
              <div class="w-50">
                 <label>Muddat (Dan)</label>
                 <input type="date" class="form-control afd-date" v-model="advancedFilters.dueDateFrom" />
              </div>
              <div class="w-50">
                 <label>Muddat (Gacha)</label>
                 <input type="date" class="form-control afd-date" v-model="advancedFilters.dueDateTo" />
              </div>
           </div>
        </div>
        
        <div class="afd-footer">
           <button class="btn afd-btn-reset" @click="clearAllAdvancedFilters()">Tozalash</button>
           <button class="btn btn-primary afd-btn-apply" @click="showAdvancedFilters = false">Qo'llash</button>
        </div>
      </div>
    </div>
</template>

<script>
import api from "@/services/api";
import Swal from "sweetalert2";
import { VDateInput } from "vuetify/labs/VDateInput";
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { AgGridVue } from 'ag-grid-vue3'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community'
ModuleRegistry.registerModules([AllCommunityModule])

import CustomGantt from "./components/CustomGantt.vue";

import HelpRequestItem from "./components/HelpRequestItem.vue";
import TaskDialog from "./components/TaskDialog.vue";
import TaskFormModal from "./components/TaskFormModal.vue";
import OrgChartComponent from "./components/OrgChartComponent.vue";
import TemplateManagerModal from "./components/TemplateManagerModal.vue";
import UserStatisticsModal from "./components/UserStatisticsModal.vue";

export default {
  components: {
    VDateInput,
    FullCalendar,
    AgGridVue,
    CustomGantt,
    HelpRequestItem,
    TaskDialog,
    OrgChartComponent,
    TaskFormModal,
    TemplateManagerModal,
    UserStatisticsModal
  },
  name: "KanbanBoard",
  data() {
    return {
      taskInterval: null,
      isTasksLoading: false,
      activeTab: 'project',
      activeWorkspaceId: null,
      templateManagerDialog: false,
      selectedTemplateData: null,
      taskTemplates: [], // Endi backenddan keladi
      subTaskName: '',
      subTaskDescription: '',
      subTaskDate: [],
      showModal: false,
      modalX: 0,
      modalY: 0,
      modalType: null,
      allHelpRequests: [],
      myHelpRequests: [],
      incomingHelpRequests: [],
      invitesListDialog: false,
      helpMessage: '',
      selectedHelpUser: null,
      getHelpDialog: false,
      isWideSearch: false,
      gridApi: null,
      columnApi: null,
      quickFilterText: '',
      
      showAdvancedFilters: false,
      advancedFilters: {
        assignees: [],
        creators: [],
        statuses: [],
        dueDateFrom: null,
        dueDateTo: null,
        onlyOverdue: false,
      },

      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 50,
        //   pinned: 'left',
          filter: false,
          sortable: false,
        },
        { headerName: 'ID', field: 'id', width: 80, sortable: true, filter: true },
        { headerName: 'Task Nomi', field: 'task_name', sortable: true, filter: true, width: 300 },
        { headerName: 'Created by', field: 'created_by', sortable: true, filter: true, width: 200 },
        { 
          headerName: 'Ijrochi', 
          field: 'assignee', 
          sortable: true, 
          filter: true, 
          width: 200,
          cellRenderer: (params) => this.assigneeRenderer(params)
        },
        {
          headerName: 'Status',
          field: 'status',
          width: 130,
          cellRenderer: (params) => this.statusRenderer(params),
          sortable: true,
          filter: true,
        },
        {
          headerName: 'Deadline %',
          field: 'progress',
          width: 140,
          cellRenderer: (params) => this.progressRenderer(params),
          sortable: true,
        },
        { headerName: 'Boshlanish', field: 'created_at', sortable: true, filter: 'agDateColumnFilter', width: 140 },
        { headerName: 'Tugash', field: 'task_deadline', sortable: true, filter: 'agDateColumnFilter', width: 140 },
        {
          headerName: 'Performans',
          field: 'performance',
          width: 130,
          cellRenderer: (params) => this.performanceRenderer(params),
          sortable: true,
        },
      ],

      rowData: [],
      currentRawTasks: [],
      newMember: { user_id: null, process: null },
      selectedMembers: [],

      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        locales: [{
          code: 'uz',
          buttonText: { prev: "Oldingi", next: "Keyingi", today: "Bugun", month: "Oy", week: "Hafta", day: "Kun", list: "Kun tartibi" },
          allDayText: "Kun bo'yi",
          moreLinkText: (n) => "+ yana " + n,
          noEventsText: "Vazifalar yo'q"
        }],
        locale: 'uz',
        selectable: true,
        editable: false,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek'
        },
        height: 'calc(100vh - 200px)',
        dayMaxEvents: true, // + N yana buttonini yoqadi
        events: [],
        eventContent: (arg) => {
          const task = arg.event.extendedProps;
          let avatarHtml = '';
          const members = task.task_members || task.members || [];
          if (members && members.length > 0) {
             const exec = members.find(m => m.process === "Ijro") || members[0];
             // check if this is bound
             const avatarUrl = typeof this.getEmployeeAvatar === 'function' 
                 ? this.getEmployeeAvatar(exec.user_id) 
                 : `https://ui-avatars.com/api/?name=${exec.user_fullname || 'User'}&background=random`;
             if (avatarUrl) {
               avatarHtml = `<img src="${avatarUrl}" onerror="this.src='https://ui-avatars.com/api/?name=User'" style="width:22px;height:22px;border-radius:50%;object-fit:cover;margin-right:6px;border:1.5px solid rgba(255,255,255,0.8);box-shadow: 0 1px 3px rgba(0,0,0,0.1); flex-shrink:0;" />`;
             }
          }
          let timeStr = '';
          if (task.deadline) {
             const d = new Date(task.deadline);
             const hrs = String(d.getHours()).padStart(2,'0');
             const mins = String(d.getMinutes()).padStart(2,'0');
             timeStr = `<span style="font-size:11px; font-weight:600; opacity:0.9; margin-bottom:2px; display:block; letter-spacing:0.3px;">${hrs}:${mins} gacha</span>`;
          }
          return {
            html: `<div class="custom-cal-event" style="display:flex; flex-direction:column; padding: 4px 6px; overflow:hidden; color: #fff; text-shadow: 0 1px 2px rgba(0,0,0,0.1);" title="${arg.event.title}">
                     ${timeStr}
                     <div style="display:flex; align-items:center;">
                        ${avatarHtml}
                        <b style="font-size:12px; font-weight:500; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${arg.event.title}</b>
                     </div>
                   </div>`
          };
        },
        eventClick: (info) => {
          this.openTask(info.event.extendedProps);
        }
      },
      chart: null,
      currentZoom: 'month',
      zoomLevels: [
        { label: 'Day', value: 'day' },
        { label: 'Week', value: 'week' },
        { label: 'Month', value: 'month' },
        { label: 'Year', value: 'year' }
      ],
      viewMode: 'board',
      selectedWorkspaceName: "",
      myWorkSpaces: [],
      teams: [],
      newWorkSpaceName: "",
      newWorkSpaceDescription: "",
      selectedStructureId: "",
      workSpaceInput: false,
      myEmployees: [],
      prevEmployees: [],
      showPdfModal: false,
      checkedByCreator: false,
      isSidebarOpen: true,
      pdfUrl: null,
      pdfFileName: "",
      comment_file_path: null,
      zoomLevel: 1,
      commentPreviewUrl: null,
      previewUrl: null, // rasm uchun blob URL
      showImageModal: false, // kattalashtirish uchun
      editTaskDialog: false,
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        cardId: null,
      },
      teamMems: [],
      redirectToEmployeeId: null,
      redirectToEmployeeDialog: false,
      selectedTaskId: null,
      excelFile: null,
      fileDialog: false,
      fileName: null,
      commentMessage: null,
      commentFile: null,
      activePanel: false,
      taskListName: null,
      createdTasksCount: null,
      incomingTasksCount: null,
      infoTasksCount: null,
      finishedTasksCount: null,
      deletedTasksCount: null,
      filteredTasksByTypeId: null,
      openTaskListDialog: false,
      selectedTask: null,
      taskModal: false,
      orgChartModel: false,
      userStatisticsDialog: false,
      search: "",
      selectedApprovedTasks: [],
      selectAllApproved: false,
      columns: [
        {
          id: 1,
          title: "Yangi topshiriqlar",
          editing: false,
          newText: "",
          showInput: false,
          cards: [],
          collapsed: false
        },
        {
          id: 2,
          title: "Jarayonda",
          editing: false,
          newText: "",
          showInput: false,
          cards: [],
          collapsed: false
        },
        {
          id: 3,
          title: "Yakunlangan",
          editing: false,
          newText: "",
          showInput: false,
          cards: [],
          collapsed: false
        },
        {
          id: 4,
          title: "Tasdiqlangan",
          editing: false,
          newText: "",
          showInput: false,
          cards: [],
          collapsed: false
        },
      ],
      drag: {
        fromCol: null,
        fromIndex: null,
        cardId: null,
        overCol: null,
        overIndex: null,
        insertAbove: false,
      },
      createTaskDialog: false,
      selfTaskDialog: false,
      selectedTaskForEdit: null,
      fileUploadName: "",
      isWideSearch: false,
      employees: [],
      processes: ["Rozilik", "Ijro", "Malumot", "Test"],
      today: new Date().toISOString().slice(0, 10),
    };
  },
  computed: {
    // Store'ga user asinxron yuklanadi — shuning uchun computed (data snapshot emas)
    userId() {
      return this.$store.state.user?.id ?? null;
    },
    filteredRawTasks() {
      if (!this.currentRawTasks) return [];
      return this.filteredCards(this.currentRawTasks);
    },
    activeFilterCount() {
      let count = 0;
      if (this.advancedFilters.assignees.length) count += this.advancedFilters.assignees.length;
      if (this.advancedFilters.creators.length) count += this.advancedFilters.creators.length;
      if (this.advancedFilters.statuses.length) count += this.advancedFilters.statuses.length;
      if (this.advancedFilters.dueDateFrom) count++;
      if (this.advancedFilters.dueDateTo) count++;
      if (this.advancedFilters.onlyOverdue) count++;
      return count;
    },
    activeFilterLabels() {
      const labels = [];
      if (this.advancedFilters.assignees.length) {
         labels.push({ type: 'assignee', text: `Ijrochi: ${this.advancedFilters.assignees.length} ta` });
      }
      if (this.advancedFilters.creators.length) {
         labels.push({ type: 'creator', text: `Muallif: ${this.advancedFilters.creators.length} ta` });
      }
      if (this.advancedFilters.statuses.length) {
         labels.push({ type: 'status', text: `Status: ${this.advancedFilters.statuses.length} ta` });
      }
      if (this.advancedFilters.dueDateFrom) {
         labels.push({ type: 'dateFrom', text: `Sana (dan): ${this.advancedFilters.dueDateFrom}` });
      }
      if (this.advancedFilters.dueDateTo) {
         labels.push({ type: 'dateTo', text: `Sana (gacha): ${this.advancedFilters.dueDateTo}` });
      }
      if (this.advancedFilters.onlyOverdue) {
         labels.push({ type: 'overdue', text: `Muddati o'tganlar` });
      }
      return labels;
    },
    isCreateTaskDisabled() {
      return (
        this.activeWorkspaceId &&
        this.activeWorkspaceId !== 'Undefined' &&
        this.myEmployees.length > 0
      );
    },
    // O'zi uchun topshiriqqa bajaruvchi xodim kerak emas — faqat loyiha tanlangan bo'lsa yetarli
    isSelfTaskEnabled() {
      return !!(
        this.activeWorkspaceId &&
        this.activeWorkspaceId !== 'Undefined' &&
        this.activeWorkspaceId != 0
      );
    },
    sliderStyle() {
      return this.activeTab === 'project'
        ? { transform: 'translateX(0%)' }
        : { transform: 'translateX(100%)' }
    },

    dateText() {
      if (!this.subTaskDate[0] || !this.subTaskDate[1]) {
        return 'Add dates'
      }

      const fmt = (d) =>
        new Date(d).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short'
        })

      return `${fmt(this.subTaskDate[0])} – ${fmt(this.subTaskDate[this.subTaskDate.length - 1])}`
    },
    availableEmployees() {
      const selectedIds = this.selectedMembers.map((member) => member.user_id);
      return this.myEmployees.filter(
        (employee) => !selectedIds.includes(employee.id)
      );
    },
    availableEmployeesForHelp() {
      const selectedIds = this.selectedMembers.map((member) => member.user_id);
      return this.employees.filter(
        (employee) => !selectedIds.includes(employee.id)
      );
    },
    availableProcesses() {
      const singleAssignmentProcesses = ["Rozilik", "Ijro"];
      const usedProcesses = this.selectedMembers
        .filter((member) => singleAssignmentProcesses.includes(member.process))
        .map((member) => member.process);
      return this.processes.filter(
        (process) =>
          !usedProcesses.includes(process) ||
          !singleAssignmentProcesses.includes(process)
      );
    },
    myTeams() {
      return this.teams ? this.teams.filter(t => t.is_owner) : [];
    },
    currentUser() {
      // Return user data directly from store or localStorage
      return this.$store.state.user || JSON.parse(localStorage.getItem('user') || '{}');
    }
  },
  async created() {
    await this.fetchTasks(null, true);
    this.taskInterval = setInterval(() => {
      this.fetchTasks();
    }, 10000);
  },
  beforeUnmount() {
    if (this.taskInterval) {
      clearInterval(this.taskInterval);
      this.taskInterval = null;
    }
  },
  mounted() {
    this.ensureCurrentWorkspaceId();
    this.getTeams();
    this.getHelpRequests();
    this.getEmployees();
    this.getMyOrganizationEmployees();
    this.getMyWorkSpaces();
    this.getAllViewData();
    this.fetchTaskTemplates();
  },
  watch: {
    filteredRawTasks: {
      handler(newTasks) {
        if (!newTasks) return;
        const now = new Date();
        this.calendarOptions.events = newTasks.map(task => {
          let hasDeadline = !!task.deadline;
          let dateStr = task.deadline || task.created_at;
          let isPast = hasDeadline && new Date(dateStr) < now;
          let isFinished = [3, 4].includes(task.column_id);
          
          let bgColor = '#3b82f6';
          if (isFinished) bgColor = '#10b981';
          else if (isPast) bgColor = '#ef4444';
          else if (task.column_id === 2) bgColor = '#f59e0b';
          
          return {
            id: String(task.id),
            title: task.text,
            start: dateStr, 
            end: dateStr, 
            allDay: true,
            backgroundColor: bgColor,
            borderColor: 'transparent',
            extendedProps: task
          }
        });
      },
      immediate: true
    },
    taskDeadlineFormatted(newVal) {
      if (newVal) {
        const d = new Date(newVal);
        this.taskDeadline = d.toLocaleDateString("en-CA");
      }
    },
    activePanel(newVal) {
      if (newVal === "comments" && this.selectedTask?.id) {
        this.markCommentsAsRead(this.selectedTask.id);
      }
    },
    isWideSearch(newVal) {
      if (newVal) {
        this.prevEmployees = [...this.myEmployees];
        this.myEmployees = this.employees.filter(e => e.id !== this.userId);
      } else {
        this.myEmployees = [...this.prevEmployees];
      }
    },
    viewMode(newMode) {
      if (newMode === 'gantt' && this.currentRawTasks) {
        // Timeline renders reactively via CustomGantt automatically
      }
    }
  },
  methods: {
    getPremiumStatusColor(status) {
      if (!status) return '#3b82f6';
      const s = status.toLowerCase();
      if (s.includes('yangi')) return '#3b82f6';
      if (s.includes('bajarilmoq') || s.includes('jarayon')) return '#f59e0b';
      if (s.includes('tekshir')) return '#8b5cf6';
      if (s.includes('tugatil') || s.includes('bajarildi') || s.includes('tasdiq')) return '#10b981';
      if (s.includes('arxiv')) return '#64748b';
      if (s.includes('bekor') || s.includes('rad')) return '#ef4444';
      return '#3b82f6';
    },
    getPremiumStatusBgColor(status) {
      if (!status) return 'rgba(59, 130, 246, 0.1)';
      const s = status.toLowerCase();
      if (s.includes('yangi')) return 'rgba(59, 130, 246, 0.1)';
      if (s.includes('bajarilmoq') || s.includes('jarayon')) return 'rgba(245, 158, 11, 0.1)';
      if (s.includes('tekshir')) return 'rgba(139, 92, 246, 0.1)';
      if (s.includes('tugatil') || s.includes('bajarildi') || s.includes('tasdiq')) return 'rgba(16, 185, 129, 0.1)';
      if (s.includes('arxiv')) return 'rgba(100, 116, 139, 0.1)';
      if (s.includes('bekor') || s.includes('rad')) return 'rgba(239, 68, 68, 0.1)';
      return 'rgba(59, 130, 246, 0.1)';
    },
    toggleTaskSelection(taskId) {
      const index = this.selectedApprovedTasks.indexOf(taskId);
      if (index === -1) {
        this.selectedApprovedTasks.push(taskId);
      } else {
        this.selectedApprovedTasks.splice(index, 1);
      }
    },
    toggleSelectAllApproved(col) {
      this.selectAllApproved = !this.selectAllApproved;
      if (this.selectAllApproved) {
        this.selectedApprovedTasks = this.filteredCards(col.cards || [])
          .filter(c => c.user_id == this.userId)
          .map(c => c.id);
      } else {
        this.selectedApprovedTasks = [];
      }
    },
    async bulkAcceptTasks() {
      if (this.selectedApprovedTasks.length === 0) return;

      const result = await Swal.fire({
        title: "Tasdiqlaysizmi?",
        text: `Siz ${this.selectedApprovedTasks.length} ta topshiriqni qabul qilmoqchisiz.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ha!",
        cancelButtonText: "Yo'q"
      });

      if (result.isConfirmed) {
        this.isTasksLoading = true;
        try {
          await api.post("/accept-task", { 
            task_ids: this.selectedApprovedTasks 
          });
          
          Swal.fire({
            icon: 'success',
            title: 'Muvaffaqiyat!',
            text: 'Tanlangan topshiriqlar muvaffaqiyatli qabul qilindi.',
            timer: 2000,
            showConfirmButton: false
          });
          
          this.selectedApprovedTasks = [];
          this.selectAllApproved = false;
          await this.fetchTasks();
        } catch (error) {
          console.error("Bulk accept error:", error);
          this.showError("Topshiriqlarni qabul qilishda xatolik yuz berdi.");
        } finally {
          this.isTasksLoading = false;
        }
      }
    },
    fetchTaskTemplates() {
      api.get('/task-templates')
        .then(response => {
          const rawTemplates = response.data?.data || response.data || [];
          
          this.taskTemplates = rawTemplates.map(item => {
            return {
              id: item.id,
              name: item.name,
              description: item.description,
              icon: item.icon || 'fa-solid fa-file-lines',
              task: {
                taskName: item.task_name || item.name,
                taskDescription: item.task_description || item.description,
                selectedMembers: [], 
                subtasks: (item.subtasks || item.task_templates_subtasks || []).map(sub => ({
                  name: sub.name,
                  description: sub.description,
                  assignee: { user_id: null, process: "Ijro" }
                }))
              }
            }
          });
        })
        .catch(error => {
          console.error("Shablonlarni yuklashda xatolik:", error);
        });
    },
    removeAdvancedFilter(type) {
       if (type === 'assignee') this.advancedFilters.assignees = [];
       if (type === 'creator') this.advancedFilters.creators = [];
       if (type === 'status') this.advancedFilters.statuses = [];
       if (type === 'dateFrom') this.advancedFilters.dueDateFrom = null;
       if (type === 'dateTo') this.advancedFilters.dueDateTo = null;
       if (type === 'overdue') this.advancedFilters.onlyOverdue = false;
    },
    clearAllAdvancedFilters() {
       this.advancedFilters = { assignees: [], creators: [], statuses: [], dueDateFrom: null, dueDateTo: null, onlyOverdue: false };
    },
    toggleAssigneeFilter(id) {
       const index = this.advancedFilters.assignees.indexOf(id);
       if (index === -1) {
          this.advancedFilters.assignees.push(id);
       } else {
          this.advancedFilters.assignees.splice(index, 1);
       }
    },
    closeOrgChart() {
      this.orgChartModel = false
    },
    downloadExcel() {
      const date = '2025-12';

      api.get(`/get-department-hours?date=${date}`, {
        responseType: 'blob',
      })
      .then((response) => {
        // faylni yaratish
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `department_hours_${date}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.error('Download error:', error);
      });
    },
    async saveSubtask(card) {
      const payload = this.buildSubtaskPayload();
      const errors = this.validatePayload(payload);

      if (errors.length) {
        Swal.fire({
          icon: 'warning',
          title: 'Xatolik',
          text: errors[0], // <-- birinchi xato
          confirmButtonText: 'Tushundim'
        });
        return;
      }

      try {
        await api.post('/create-subtask/' + card.id, payload);
        Swal.fire({
          icon: 'success',
          title: 'Muvaffaqiyatli',
          text: 'Subtask muvaffaqiyatli yaratildi.',
          confirmButtonText: 'Yaxshi'
        });
        this.showModal = false;
        card.subtaskForm = false;
        card.subtasks.unshift({
          name: payload.name,
          description: payload.description,
          dates: payload.dates,
          members: payload.members,
          created: true,
        });
      } catch (e) {
        console.error(e);
        alert("Saqlashda xatolik yuz berdi.");
      }
    },

    validatePayload(p) {
      const errors = [];

      if (!p.name) errors.push("Subtask nomini kiriting!");
      
      if (!p.description) errors.push("Subtask matnini kiriting!");

      if (!p.members.length) errors.push("Xodim kiriting!");
      
      if (!p.dates.length) errors.push("Subtask sanasini kiriting!");

      return errors;
    },
    buildSubtaskPayload() {
      const name = (this.subTaskName || '').trim();
      const description = (this.subTaskDescription || '').trim();

      const toYMD = d => {
        const x = new Date(d)
        const y = x.getFullYear()
        const m = String(x.getMonth() + 1).padStart(2, '0')
        const day = String(x.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      }

      const dates = Array.isArray(this.subTaskDate)
        ? this.subTaskDate.map(toYMD)
        : []

      const members = this.selectedMembers;

      return {
        name,
        description,
        dates,
        members,
      };
    },
    openModal(event, type) {
      const parent = event.currentTarget.closest('.subtask-form');
      const parentRect = parent.getBoundingClientRect();

      // Y — click joyi
      const y = event.clientY;

      this.modalX = 0; // parent chapidan boshlab
      this.modalY = y - parentRect.top + 25;

      this.modalType = type;
      this.showModal = true;
    },


    subtaskForm(card) {
      card.subtaskForm = true
      card.isSubtasksOpen = true
      this.$nextTick(() => {
        const inputs = this.$refs.subtaskInputs
        if (Array.isArray(inputs) && inputs.length) {
          inputs[inputs.length - 1].focus()
        }
      })
    },

    toggleSubtasks(card) {
      if (card) {
        card.isSubtasksOpen = !card.isSubtasksOpen
      }
    },

    async acceptRequest(requestId) {
      await api.post('/accept-help-request', {
        request_id: requestId
      })
      .then(() => {
        this.fetchTasks();
        this.getHelpRequests();
        this.invitesListDialog = false;
      })
      .catch(error => {
        console.error('Error accepting help request:', error);
      });
    },
    rejectRequest(requestId) {
      api.post('/reject-help-request', {
        request_id: requestId
      })
      .then(() => {
        this.getHelpRequests();
      })
      .catch(error => {
        console.error('Error rejecting help request:', error);
      });
    },
    getHelpRequests() {
      api.get('/get-help-requests')
      .then(response => {
        this.allHelpRequests = response.data.allRequests;
        this.myHelpRequests = response.data.myRequests;
        this.incomingHelpRequests = response.data.incomingRequests;
      })
      .catch(error => {
        console.error('Error fetching help requests:', error);
      });
    },

    sendHelpRequest() {
      api.post('/task-help-request', {
        to_user_id: this.selectedHelpUser,
        task_id: this.selectedTask.id,
        message: this.helpMessage
      })
      .then(response => {
        // Handle success
        console.log('Help request sent:', response.data);
        this.getHelpDialog = false;
        this.getHelpRequests();
        this.helpMessage = '';
        this.selectedHelpUser = null;
      })
      .catch(error => {
        // Handle error
        console.error('Error sending help request:', error);
      });
    },

    getHelp() {
      this.getHelpDialog = true;
      this.selectedMembers = this.selectedTask.members;
    },
    getAllViewData() {
      api.get('/all-view-datas')
        .then(response => {
          this.rowData = response.data;
        })
        .catch(error => {
          // Handle any errors
          console.error(error);
        });
    },
    openCreateTaskModal() {
      this.selectedTemplateData = null;
      this.createTaskDialog = true;
    },
    // Faqat o'zi uchun topshiriq — bajaruvchi xodim talab qilinmaydi
    openSelfTaskModal() {
      this.selectedTemplateData = null;
      this.selfTaskDialog = true;
    },
    useTemplate(template) {
      this.selectedTemplateData = template.task;
      this.createTaskDialog = true;
    },
    copyTask(task) {
      this.selectedTemplateData = {
        taskName: task.text || task.task_name || "",
        taskDescription: task.description || task.task_description || "",
        subtasks: task.subtasks ? task.subtasks.map(st => ({
          name: st.name,
          description: st.description || "",
          deadline: st.deadline || null,
          assignees: st.assignees ? st.assignees.map(m => ({ user_id: m.user_id, process: m.process })) : []
        })) : []
      };
      this.createTaskDialog = true;
    },
    openTemplateManager() {
      this.templateManagerDialog = true;
    },
    shortColumn(cIdx) {
      this.columns[cIdx].collapsed = !this.columns[cIdx].collapsed;
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi

      // Boshlang'ichda kolonkalarni moslashtirish
      setTimeout(() => {
        try { this.gridApi.sizeColumnsToFit() } catch (e) {
            // ignore resize errors
        }
      }, 50)

      // Ekran kattaligi o'zgarganda moslashtirish
      window.addEventListener('resize', this.onWindowResize)
    },

    onWindowResize() {
      if (this.gridApi) {
        try { this.gridApi.sizeColumnsToFit() } catch (e) {
            // ignore resize errors
        }
      }
    },

    exportCsv() {
      if (!this.gridApi) return
      this.gridApi.exportDataAsCsv({
        fileName: 'tasks.csv',
        allColumns: true,
      })
    },

    clearFilters() {
      if (!this.gridApi) return
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.quickFilterText = ''
    },

    deleteSelected() {
      Swal.fire({
        title: 'Haqiqatan ham tanlangan qatorlarni o‘chirmoqchimisiz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ha, o‘chirilsin',
        cancelButtonText: 'Bekor qilish',
      }).then((result) => {
        if (result.isConfirmed) {
          if (!this.gridApi) return
          const selected = this.gridApi.getSelectedRows()
          if (!selected || selected.length === 0) {
            alert('Hech narsa tanlanmadi.')
            return
          }
          this.gridApi.applyTransaction({ remove: selected })
        }
      })
    },

    statusRenderer(params) {
      const status = params.value
      let color = '#95a5a6'
      if (status === 'Bajarildi') color = '#2ecc71'           // Yashil – bajarildi
      else if (status === 'Jarayonda') color = '#f1c40f'     // Sariq – jarayonda
      else if (status === 'Yangi') color = '#95a5a6'         // Kulrang – yangi, hali boshlanmagan
      else if (status === 'Qabul qilindi') color = '#3498db'  // Moviy – qabul qilingan
      else if (status === 'Tasdiqlandi') color = '#9b59b6'    // To'q binafsha – tasdiqlangan
      return `<span style="background:${color}; color:white; padding:4px 8px; border-radius:4px; font-size:12px;">${status}</span>`
    },

    assigneeRenderer(params) {
      if (!params.data) return '';
      const members = params.data.task_members || params.data.members || [];
      if (Array.isArray(members) && members.length) {
         const ijro = members.find(m => m.process === 'Ijro') || members[0];
         if (ijro) {
           return `<span>${ijro.user_fullname || ijro.name || 'Xodim ID: ' + ijro.user_id}</span>`;
         }
      }
      return `<span>${params.data.assignee || 'Ko\'rsatilmagan'}</span>`;
    },

    progressRenderer(params) {
      if (!params.data) return '';
      
      const value = this.getRemainingProgress(params.data);
      const colorClass = this.getDeadlineProgressColor(params.data);
      
      let hexColor = '#0dcaf0'; // fallback bg-info
      if (colorClass === 'bg-success') hexColor = '#10b981'; // yashil
      else if (colorClass === 'bg-danger' || colorClass === 'bg-danger1') hexColor = '#ef4444'; // qizil
      else if (colorClass === 'bg-warning') hexColor = '#f59e0b'; // sariq
      else if (colorClass === 'bg-info') hexColor = '#3b82f6'; // havorang/kok

      return `
        <div style="display:flex; align-items:center; height:100%;">
          <div style="background:#e0e0e0; border-radius:4px; width:80px; height:8px; margin-right:8px; overflow:hidden;">
            <div style="background:${hexColor}; width:${value}%; height:100%; border-radius:4px; min-width:3%; transition: width 0.3s ease;"></div>
          </div>
          <span style="font-size:12px; font-weight:600; color:#555;">${value}%</span>
        </div>
      `
    },

    performanceRenderer(params) {
      let status = params.data.status;
      let dateNow = new Date();
      let deadline = new Date(params.data.task_deadline);

      // Har ikkisini "faqat sana" holatiga keltiramiz (soat qismini olib tashlaymiz)
      dateNow.setHours(0, 0, 0, 0);
      deadline.setHours(0, 0, 0, 0);

      // Farqni millisekundlarda hisoblaymiz
      let diffTime = deadline - dateNow;

      // Kunlarga aylantiramiz
      let diffDays = diffTime / (1000 * 60 * 60 * 24);
      let color = null;
      if((status == 'Yangi' || status == 'Jarayonda') && diffDays <= 0 ) {
        color = '#f44336'
      }else {
        color = '#4caf50'
      }
      return `<span style="color:${color}; font-weight:bold;">${Math.abs(diffDays)} kun</span>`
    },

    setZoom(type) {
      if (!this.chart) return;

      this.currentZoom = type;

      const xAxis = this.chart.xAxis[0];
      const range = {
        day: 1000 * 60 * 60 * 24 * 7,
        week: 1000 * 60 * 60 * 24 * 30,
        month: 1000 * 60 * 60 * 24 * 90,
        year: 1000 * 60 * 60 * 24 * 365
      };

      const center = (xAxis.min + xAxis.max) / 2;
      const half = range[type] / 2;

      xAxis.setExtremes(center - half, center + half, true, true);
    },
    canMoveNext() {
      if (this.selectedTask.column_id === 1 && this.selectedTask.members.some(member => member.user_id === this.userId && (member.process === "Ijro" || member.process === "Rozilik"))) return true;
      if (this.selectedTask.column_id === 2 && this.selectedTask.members.some(member => member.user_id === this.userId && member.process === "Ijro")) return true;
      if (this.selectedTask.column_id === 3 && this.selectedTask.user_id === this.userId) return true;
      return false;
    },
    canMoveBack() {
      if (this.selectedTask.column_id === 2 && this.selectedTask.members.some(member => member.user_id === this.userId && (member.process === "Ijro" || member.process === "Rozilik"))) return true;
      if (this.selectedTask.column_id === 3 && (this.selectedTask.user_id === this.userId || this.selectedTask.members.some(member => member.user_id === this.userId && member.process === "Ijro"))) return true;
      if (this.selectedTask.column_id === 4 && this.selectedTask.user_id === this.userId) return true;
      return false;
    },
    updateTask(id) {
      if (!this.taskName.trim()) {
        alert("Iltimos, topshiriq nomini kiriting!");
        return;
      }

      const hasExecutor = this.selectedMembers.some(
        (member) => member.process === "Ijro"
      );
      if (!hasExecutor) {
        Swal.fire({
          icon: "warning",
          title: "Diqqat!",
          text: "Ijro uchun xodim biriktiring",
          confirmButtonText: "Ok",
        });
        return;
      }

      const payload = new FormData();
      payload.append("text", this.taskName);
      payload.append("description", this.taskDescription || "");
      payload.append("deadline", this.taskDeadline || "");
      if (this.file) {
        payload.append("file", this.file);
      }
      payload.append("members", JSON.stringify(this.selectedMembers));

      api
        .post("/update-task/" + id, payload)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Muvaffaqiyat",
            text: "Topshiriq muvaffaqiyatli yangilandi!",
            confirmButtonText: "Ok",
          });
          this.editTaskDialog = false;
          this.resetForm();
          this.fetchTasks();
          this.selectedTaskId = null;
          this.taskModal = false;
        })
        .catch((error) => {
          console.error("❌ Error:", error.response?.data || error.message);
          Swal.fire({
            zIndex: 2000,
            icon: "error",
            title: "Xato",
            text: error.response?.data?.message || "Xato yuz berdi!",
          });
        });
    },
    openContextMenu(event, card) {
      this.contextMenu = {
        visible: true,
        x: event.x,
        y: event.y,
        cardId: card.id,
      };
      // tashqariga bosilganda menyuni yopish
      document.addEventListener("click", this.closeContextMenu);
    },
    closeContextMenu(event) {
      // Agar click context-menu ichida bo‘lsa -> yopmaydi
      const menu = this.$refs.contextMenu;
      if (menu && menu.contains(event.target)) return;

      // Aks holda yopadi
      this.contextMenu.visible = false;
      document.removeEventListener("click", this.closeContextMenu);
    },
    handleConfirm() {
      api
        .post("/attach-task-to-user", {
          redirectToEmployeeId: this.redirectToEmployeeId,
          task_id: this.selectedTaskId,
        })
        .then(() => {
          this.redirectToEmployeeDialog = false;
          this.redirectToEmployeeId = null;
          this.selectedTaskId = null;
          this.taskModal = false;
          this.fetchTasks();
        })
        .catch((error) => {
          this.redirectToEmployeeDialog = false;
          console.error("❌ Error:", error.response?.data || error.message);
          Swal.fire({
            zIndex: 2000,
            icon: "error",
            title: "Xato",
            text: error.response?.data?.message || "Xato yuz berdi!",
          });
        });
    },
    getDaysLeft(card) {
      if (!card.deadline) return "";
      const today = new Date();
      const deadline = new Date(card.deadline);
      today.setHours(0, 0, 0, 0);
      deadline.setHours(0, 0, 0, 0);
      const diff = deadline - today;
      return Math.floor(diff / (1000 * 60 * 60 * 24));
    },
    redirectToEmployee(taskId) {
      this.selectedTaskId = taskId;
      this.redirectToEmployeeDialog = true;
    },
    handleExcelFile(event) {
      this.excelFile = event.target.files[0];
    },
    async uploadExcel() {
      // Fayl tanlanmagan bo‘lsa
      if (!this.excelFile) {
        alert("Iltimos, Excel fayl tanlang!");
        return;
      }

      try {
        // FormData yaratamiz
        let formData = new FormData();
        formData.append("file", this.excelFile, this.excelFile.name);

        // So‘rov yuborish
        const res = await api.post(
          "/create-task-file",
          formData,
          {
            headers: {
              // api o‘zi multipart qo‘yadi, lekin aniqroq qilish uchun qo‘shib qo‘ysak ham bo‘ladi
              "Content-Type": "multipart/form-data",
            },
          }
        );

        // Javobni ko‘rish
        console.log("Tasks imported:", res.data);

        // Foydalanuvchiga xabar
        alert("Excel muvaffaqiyatli yuklandi!");

        // Modalni yopish va faylni tozalash
        this.fileDialog = false;
        this.excelFile = null;
      } catch (error) {
        console.error("Xato:", error.response?.data || error.message || error);
        alert("Xatolik yuz berdi! Konsolni tekshiring.");
      }
    },

    closeTask() {
      this.taskModal = false;
      this.activePanel = false;
      this.selectedTask = [];
      this.removeFile();
    },

    incrementCommentCount(taskId) {
      for (let col of this.columns) {
        if (col.cards && Array.isArray(col.cards)) {
          let card = col.cards.find(c => c.id === taskId);
          if (card) {
            card.comments_count = (card.comments_count || 0) + 1;
            break;
          }
        }
      }
    },

    async checkTask(id) {
      await api.post("/task-check", { task_id: id });
      this.fetchTasks();
      this.taskModal = false;
    },

    async taskCounts() {
      await api
        .get("/task-counts", {
          params: {
            projectId: this.activeWorkspaceId
          },
          meta: { al: false }
        })
        .then((res) => {
          (this.createdTasksCount = res.data.myTasksCount),
            (this.incomingTasksCount = res.data.assignedToCount),
            (this.infoTasksCount = res.data.infoCount),
            (this.finishedTasksCount = res.data.finishedTasksCount);
            (this.deletedTasksCount = res.data.deletedTasksCount);
        });
    },

    async finishTask(id) {
      this.taskModal = false;
      await api.post("/accept-task", {
        task_id: id,
      });

      await this.fetchTasks();
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    openTaskList(type_id) {
      const taskTypes = {
        1: "Yaratilgan topshiriqlar",
        2: "Ijroga tushgan topshiriqlar",
        3: "Ma'lumot uchun",
        4: "Arxiv",
        5: "Bekor qilingan",
      };

      this.taskListName = taskTypes[type_id] || "Nomaʼlum topshiriqlar";

      this.openTaskListDialog = true;
      api
        .get("/tasks-by-type", {
          params: {
            type_id,
            projectId: this.activeWorkspaceId 
          },
        })
        .then((res) => {
          this.filteredTasksByTypeId = res.data;
        });
    },

    async getTaskFile(path, customFileName) {
      if (!path) return;
      const url = this.$store.state.fileUrl + path;
      
      try {
        // Faylni Blob ko'rinishida yuklab olamiz
        const response = await fetch(url);
        if (!response.ok) throw new Error("Faylni yuklashda xatolik");
        
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = customFileName || path.split("/").pop() || "download";
        
        document.body.appendChild(link);
        link.click();
        
        // Tozalash
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error("Blob yuklashda xatolik yuz berdi:", error);
        // Agar CORS xatosi bo'lsa yoki fetch ishlamasa, avtomat yangi oynada ochadi
        window.open(url, "_blank");
      }
    },

    openTask(card) {
      // Ensure the card object conforms to the format expected by TaskDialog
      if (!card.members && card.task_members) {
        card.members = card.task_members;
      }
      if (!card.deadline && card.task_deadline) {
        card.deadline = card.task_deadline;
      }
      if (!card.text && card.task_name) {
        card.text = card.task_name;
      }

      this.selectedTask = card;
      this.taskModal = true;
      this.invitesListDialog = false;
      // Avval eski commentlarni olib kelamiz
      this.markCommentsAsRead(card.id);
    },

    getRemainingProgress(card) {
      const deadline = card?.deadline || card?.task_deadline;
      if (!deadline) return 0;

      const createdAt = card?.created_at
        ? new Date(card.created_at)
        : new Date();
      const deadlineDate = new Date(deadline);
      const now = new Date();

      // ✅ Agar column_id 3 yoki 4 bo‘lsa progress doim 100%
      if ([3, 4].includes(card?.column_id)) {
        return 100;
      }

      // ✅ Muddatidan o‘tib ketgan bo‘lsa progress 100% bo‘ladi
      if (now >= deadlineDate) {
        return 100;
      }

      const totalTime = deadlineDate - createdAt;
      const remaining = deadlineDate - now;

      return Math.max(0, Math.floor((remaining / totalTime) * 100));
    },

    getDeadlineProgressColor(card) {
      const deadlineStr = card?.deadline || card?.task_deadline;
      if (!deadlineStr) return "bg-info";
      const deadlineDate = new Date(deadlineStr);
      const now = new Date();

      // ✅ column_id 3 yoki 4 → success (yashil)
      if ([3, 4].includes(card?.column_id)) {
        return "bg-success";
      }

      // ✅ deadline o‘tgan bo‘lsa → danger (qizil)
      if (now >= deadlineDate) {
        return "bg-danger1";
      }

      // ✅ qolgan hollarda progress foiziga qarab ranglash
      const progress = this.getRemainingProgress(card);

      if (progress > 70) return "bg-info"; // ko‘p vaqt → ko‘k (yoki yashil)
      if (progress > 30) return "bg-warning"; // o‘rtacha vaqt → sariq
      return "bg-danger"; // oz vaqt qoldi → qizil
    },

    getEmployees() {
      const project_id = localStorage.getItem("current_workspace_id");
      api.get("/task-users", {
          params: {
            project_id: project_id
          }
        })
        .then((res) => {
          // this.employees = res.data;  
          if (!res.data || !Array.isArray(res.data)) {
            return;
          }
          this.employees = res.data.map(emp => ({
            id: emp.id,
            name: `${emp.firstname} ${emp.lastname} (${emp.tabel})`,
            group: "Xodimlar",
            avatar: emp.avatar,
            tabel: emp.tabel,
          }));

          this.teamMems = res.data.slice(0, 8).map(e => ({
            id: e.id,
            tabel: e.tabel,
            name: `${e.firstname} ${e.lastname}`,
            filter: e.firstname,
          }))
        })
        .catch((error) => {
          console.error("Error fetching employees:", error);
          this.showError("Xodimlarni yuklashda xatolik yuz berdi!");
        });
    },

    setWorkspace(id) {
      const currenctWorkspaceId = localStorage.getItem('current_workspace_id') ?? null
      if(id != currenctWorkspaceId) {
        localStorage.setItem("current_workspace_id", id);
        this.activeWorkspaceId = id;
        this.fetchTasks(id, true);
        this.getMyOrganizationEmployees();
        this.getEmployees();
      }
    },

    // LocalStorage'da current_workspace_id bo‘lmasa — 0 ("Barchasi") ni o‘rnatamiz
    ensureCurrentWorkspaceId() {
      const stored = localStorage.getItem("current_workspace_id");
      if (stored === null || stored === "" || stored === "null" || stored === "undefined") {
        localStorage.setItem("current_workspace_id", 0);
        return "0";
      }
      return stored;
    },

    getMyWorkSpaces() {
      api.get("/workspaces", {meta: {al:false}})
        .then((response) => {
          this.myWorkSpaces = response.data;
          this.activeWorkspaceId = this.ensureCurrentWorkspaceId();
          if (this.activeWorkspaceId == 0) {
            this.selectedWorkspaceName = 'Barcha topshiriqlar';
          }
          else {
            const workspace = response.data.find(w => w.id == this.activeWorkspaceId);
            this.selectedWorkspaceName = workspace ? workspace.name : 'Noma\'lum loyiha';
          }
        })
        .catch((error) => {
          console.error("❌ Error:", error.response?.data || error.message);
        });
    },

    handleStructureChange() {
      if (this.selectedStructureId === 'CREATE_NEW') {
        this.selectedStructureId = ""; // clear so it resets back to "Jamoa tanlang"
        this.orgChartModel = true;     // open the org chart
      }
    },

    createWorkSpace() {
      api.post("/workspaces", {
          name: this.newWorkSpaceName,
          structure_id: this.selectedStructureId || null,
          activeTab: this.activeTab
        }, {meta: {al: false}})
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Muvaffaqiyat",
            text: "Yangi workspace yaratildi!",
            confirmButtonText: "Ok",
          });
          this.newWorkSpaceName = "";
          this.newWorkSpaceDescription = "";
          this.selectedStructureId = "";
          this.getMyWorkSpaces();
        })
        .catch((error) => {
          console.error("❌ Error:", error.response?.data || error.message);
          Swal.fire({
            zIndex: 2000,
            icon: "error",
            title: "Xato",
            text: error.response?.data?.message || "Xato yuz berdi!",
          });
        });
      this.workSpaceInput = false; // Inputni yopish
    },

    getMyOrganizationEmployees() {
      api.get("/my-employees", {
        params: {
          project_id: localStorage.getItem('current_workspace_id')
        }
      })
      .then(res => {
        this.myEmployees = res.data.map(user => ({
          id: user.id,
          name: user.firstname + " " + user.lastname,
          avatar: this.getEmployeeAvatar(user.id), // vaqtincha
          group: user.tabel
        }));
      })
      .catch(err => {
        console.error("Error loading my organization employees:", err);
      });
    },

    updateTaskDates(data) {
      const { taskObj, newStart, newEnd } = data;
      console.log('Gantt Task update requested:', data);
      
      Swal.fire({
        icon: "info",
        title: "Sana yangilanishi kutilmoqda",
        text: `"${taskObj.text}" uchun yangi muddat: ${newEnd.toLocaleDateString()}`,
        timer: 2500,
        showConfirmButton: false, 
        toast: true,
        position: 'top-end'
      });
      
      // Update local state temporarily to reflect change silently
      taskObj.deadline = newEnd.toISOString().split('T')[0];
    },
    showError(message) {
      Swal.fire({
        icon: "error",
        title: "Xato!",
        text: message,
        confirmButtonText: "OK",
      });
    },
    refreshPage() {
      // Skeleton loader ko'rinishi uchun showLoader = true
      this.fetchTasks(null, true);
      this.getTeams();
      this.getMyOrganizationEmployees();
      this.getEmployees();
      this.getMyWorkSpaces();
    },

    async markCommentsAsRead(taskId) {
      try {
        await api.post(
          "/task-comment-mark-read",
          {
            task_id: taskId,
          },
          { meta: { al: false}}
        );
        // unread countni frontendda ham nol qilib qo‘ysangiz bo‘ladi
        if (this.selectedTask.user_id === this.userId) {
          this.selectedTask.unread_count = 0;
        } else {
          // const members = JSON.parse(this.selectedTask.members || "[]");
          this.selectedTask.members.map((m) => {
            if (m.user_id === this.userId) {
              m.unread_count = 0;
            }
            // return m;
          });
          // this.selectedTask.members = JSON.stringify(updated);
        }
      } catch (e) {
        console.error("Mark as read failed", e);
      }
    },
    getTeams() {
       api.get('/teams').then(res => {
         this.teams = res.data;
       }).catch(err => console.error("Error fetching teams:", err));
    },
    async fetchTasks(id = null, showLoader = false) {
      if (showLoader) {
        this.isTasksLoading = true;
      }
      try {
        const response = await api.get("/tasks", {
            params: {
              workspace_id: id || localStorage.getItem("current_workspace_id"),
            },
          }
        );
        const tasks = response.data;

        // Preserve previous subtask states
        const prevTaskStates = {};
        this.columns.forEach(col => {
          if (col.cards) {
            col.cards.forEach(card => {
              prevTaskStates[card.id] = {
                isSubtasksOpen: card.isSubtasksOpen,
                subtaskForm: card.subtaskForm
              };
            });
          }
        });

        // Clear existing cards to avoid duplication
        this.columns.forEach((col) => (col.cards = []));

        let mappedCardsForGantt = [];

        // Map tasks to columns based on column_id
        tasks.forEach((task) => {
          const columnIndex = this.columns.findIndex(
            (col) => col.id === task.column_id
          );
          if (columnIndex !== -1) {
            const prevState = prevTaskStates[task.id] || { isSubtasksOpen: false, subtaskForm: false };
            const mappedCard = {
              id: task.id,
              text: task.task_name,
              task_number: task.task_number,
              description: task.task_description,
              file_path: task.file_path,
              members: task.task_members,
              deadline: task.task_deadline,
              created_at: task.created_at,
              updated_at: task.updated_at,
              user_id: task.user_id,
              status: task.status,
              user_fullname: task.user_fullname,
              file_name: task.file_name,
              files: task.files,
              column_id: task.column_id,
              is_checked: task.is_checked,
              comments_count: task.comments_count,
              unread_count: task.unread_count,
              subtasks: task.subtasks,
              isSubtasksOpen: prevState.isSubtasksOpen,
              subtaskForm: prevState.subtaskForm
            };
            this.columns[columnIndex].cards.push(mappedCard);
            mappedCardsForGantt.push(mappedCard);
          } else {
            console.warn(`No column found for column_id: ${task.column_id}`);
          }
        });

        // POPULATING GANTT CHART & CALENDAR (via filteredRawTasks watcher)
        this.currentRawTasks = mappedCardsForGantt;

        await this.taskCounts();
      } catch (error) {
        console.error("Error fetching tasks:", error);

        this.showError("Tarmoqda uzilish paydo bo‘ldi!");
      } finally {
        if (showLoader) {
          setTimeout(() => {
            this.isTasksLoading = false;
          }, 800);
        }
      }
    },
    addTask(cIdx) {
      const text = (this.columns[cIdx].newText || "").trim();
      if (!text) return;
      this.columns[cIdx].cards.push({ id: Date.now(), text });
      this.columns[cIdx].newText = "";
      this.columns[cIdx].showInput = false;
    },
    // removeTask(cIdx, i) {
    //   if (!confirm("Ushbu vazifani o'chirishni xohlaysizmi?")) return;
    //   const taskId = this.columns[cIdx].cards[i].id;
    //   this.columns[cIdx].cards.splice(i, 1);
    //   this.deleteTask(taskId);
    // },
    // async deleteTask(taskId) {
    //   try {
    //     await api.delete(`/tasks/${taskId}`);
    //     console.log(`Task ${taskId} deleted`);
    //   } catch (error) {
    //     console.error('Error deleting task:', error);
    //     this.showError('Vazifani o‘chirishda xatolik yuz berdi!');
    //   }
    // },
    deleteTask(taskId) {
      // Delete task from the server
      Swal.fire({
        zIndex: 2000,
        title: "Topshiriqni o'chirishni tasdiqlaysizmi?",
        icon: "warning", // error o‘rniga warning ko‘proq mos
        showCancelButton: true,
        confirmButtonText: "Ha",
        cancelButtonText: "Yo'q",
        confirmButtonColor: "#28a745", // yashil
        cancelButtonColor: "#dc3545"   // qizil
      }).then((result) => {
        if (result.isConfirmed) {
          api.post(`/delete-task/${taskId}`)
            .then(() => {
              console.log(`Task ${taskId} deleted`);
              Swal.fire({
                icon: "success",
                title: "O'chirildi",
                // text: "Vazifa muvaffaqiyatli yaratildi",
                confirmButtonText: "Ok",
              });
              this.fetchTasks();
              this.taskModal = false;
            })
            .catch((error) => {
              console.error("Error deleting task:", error);
              this.showError("Vazifani o‘chirishda xatolik yuz berdi!");
          });
        }
      });
    },
    editTask(card) {
      this.selectedTaskForEdit = card;
      this.selectedTaskId = card.id;
      this.taskModal = false;
      this.editTaskDialog = true;
    },
    filteredCards(cards) {
      if (!Array.isArray(cards)) return [];
      
      // Table mode disables these filters entirely
      if (this.viewMode === 'table') return cards;

      const q = this.search.trim().toLowerCase();
      const af = this.advancedFilters;
      const hasQ = !!q;
      const hasAf = af.assignees?.length > 0 || af.creators?.length > 0 || af.statuses?.length > 0 || af.dueDateFrom || af.dueDateTo || af.onlyOverdue;

      if (!hasQ && !hasAf) return cards;

      return cards.filter((c) => {
        if (hasQ) {
           const matchText = (
              (c.text && c.text.toLowerCase().includes(q)) ||
              (c.task_number && String(c.task_number).toLowerCase().includes(q)) ||
              (c.description && c.description.toLowerCase().includes(q)) ||
              (c.user_fullname && c.user_fullname.toLowerCase().includes(q)) ||
              (c.file_name && c.file_name.toLowerCase().includes(q))
           );
           if (!matchText) return false;
        }

        if (hasAf) {
           if (af.assignees?.length > 0) {
              const members = c.members || [];
              const subtasks = c.subtasks || [];
              const hasSelectedAssignee = members.some(m => af.assignees.includes(m.user_id) && m.process === "Ijro");
              const hasSelectedSubtaskAssignee = subtasks.some(st => 
                 (st.assignees || []).some(a => af.assignees.includes(a.user_id) && (!a.process || a.process === "Ijro"))
              );
              if (!hasSelectedAssignee && !hasSelectedSubtaskAssignee) return false;
           }

           if (af.creators?.length > 0) {
              if (!af.creators.includes(c.user_id)) return false;
           }

           if (af.statuses?.length > 0) {
              if (!af.statuses.includes(c.column_id)) return false;
           }

           if (af.onlyOverdue) {
              const d = new Date(c.deadline || c.created_at);
              d.setHours(0,0,0,0);
              const now = new Date();
              now.setHours(0,0,0,0);
              const isFinished = [3, 4].includes(c.column_id);
              if (!(d < now && !isFinished)) return false;
           }

           if (af.dueDateFrom || af.dueDateTo) {
              const d = new Date(c.deadline || c.created_at);
              d.setHours(0,0,0,0);
              
              if (af.dueDateFrom) {
                 const from = new Date(af.dueDateFrom);
                 from.setHours(0,0,0,0);
                 if (d < from) return false;
              }
              if (af.dueDateTo) {
                 const to = new Date(af.dueDateTo);
                 to.setHours(0,0,0,0);
                 if (d > to) return false;
              }
           }
        }

        return true;
      });
    },
    canDragTask(card) {
      const currentUserId = this.userId;
      if (!currentUserId) return false;

      const isCardCreator = card.user_id === parseInt(currentUserId);
      const userRole = card.members?.find(
        (member) => member.user_id === parseInt(currentUserId)
      )?.process;

      // Malumot roli bo'lsa drag-and-drop taqiqlanadi
      if (userRole === "Malumot") return false;

      // Agar foydalanuvchi yaratuvchi yoki Rozilik/Ijro rollaridan birida bo'lsa, drag ruxsat etiladi
      return isCardCreator || userRole === "Rozilik" || userRole === "Ijro";
    },
    onDragStart(fromCol, fromIndex, card) {
      if (!this.canDragTask(card)) return;
      this.drag.fromCol = fromCol;
      this.drag.cardId = card.id; // faqat id saqlaymiz
      this.drag.overCol = null;
      this.drag.overIndex = null;
      this.drag.insertAbove = false;
    },

    onDragEnd() {
      this.drag = {
        fromCol: null,
        cardId: null,
        overCol: null,
        overIndex: null,
        insertAbove: false,
      };
    },

    onDragOverColumn(colIdx, evt) {
      evt.preventDefault();
      if (!this.filteredCards(this.columns[colIdx].cards || []).length) {
        this.drag.overCol = colIdx;
        this.drag.overIndex = null;
        this.drag.insertAbove = false;
      }
    },
    onDropOnColumn(targetCol) {
      if (!this.drag.cardId) return;

      const fromIndex = this.columns[this.drag.fromCol].cards.findIndex(
        (c) => c.id === this.drag.cardId
      );
      if (fromIndex === -1) return;

      this.moveCard(this.drag.fromCol, fromIndex, targetCol, null);
    },

    onDragOverCard(colIdx, index, evt, isAbove) {
      evt.preventDefault();
      if (this.drag.fromCol === colIdx && this.drag.fromIndex === index) return;
      const rect = evt.currentTarget.getBoundingClientRect();
      const y = evt.clientY - rect.top;
      const height = rect.height;
      this.drag.overCol = colIdx;
      this.drag.overIndex = index;
      this.drag.insertAbove = isAbove || y < height / 2;
    },
    onDropOnCard(targetCol, targetIndex) {
      if (!this.drag.cardId) return;

      // Asl massivdan card’ni topamiz
      const fromIndex = this.columns[this.drag.fromCol].cards.findIndex(
        (c) => c.id === this.drag.cardId
      );
      if (fromIndex === -1) return;

      const insertIndex = this.drag.insertAbove ? targetIndex : targetIndex + 1;
      this.moveCard(this.drag.fromCol, fromIndex, targetCol, insertIndex);
    },

    async moveCard(fromCol, fromIndex, toCol, toIndex) {
      if (fromCol === null || fromIndex === null) return;

      const card = this.columns[fromCol]?.cards?.splice(fromIndex, 1)[0];
      if (!card) return;

      // Foydalanuvchi ID sini localStorage dan olish
      const currentUserId = this.userId;
      if (!currentUserId) {
        this.showError("Foydalanuvchi ID si topilmadi!");
        this.columns[fromCol].cards.splice(fromIndex, 0, card);
        return;
      }

      // Karta ma'lumotlari
      const isCardCreator = card.user_id === parseInt(currentUserId);
      const userRole = card.members?.find(
        (member) => member.user_id === parseInt(currentUserId)
      )?.process;

      // Ustunlar indekslari asosida nomlarni aniqlash
      const columnMap = {
        1: "Yangi topshiriqlar",
        2: "Jarayonda",
        3: "Yakunlangan",
        4: "Tasdiqlangan",
      };

      const fromColumnName = columnMap[this.columns[fromCol].id];
      const toColumnName = columnMap[this.columns[toCol].id];

      // Agar subtasklari tugallanmagan bo'lsa Yakunlangan ustunga o'tkazishni bloklash
      if (toColumnName === "Yakunlangan" && fromColumnName !== "Yakunlangan") {
        const hasUncompletedSubtasks = card.subtasks && card.subtasks.some(st => st.status !== 'Bajarildi' && st.done !== true);
        if (hasUncompletedSubtasks) {
          this.showError("Barcha subtasklar yakunlanmagunicha asosiy vazifani yakunlab bo'lmaydi.");
          // Bekor qilish
          this.columns[fromCol].cards.splice(fromIndex, 0, card);
          return;
        }
      }

      // Ko'chirish qoidalarini tekshirish
      let isMoveAllowed = false;

      if (isCardCreator) {
        // Yaratuvchi: faqat Yakunlangan (3) ↔ Tasdiqlangan (4)
        if (
          (fromColumnName === "Yakunlangan" && toColumnName === "Tasdiqlangan" && card.is_checked === true) ||
          (fromColumnName === "Tasdiqlangan" && toColumnName === "Yakunlangan") ||
          (fromColumnName === "Tasdiqlangan" && toColumnName === "Tasdiqlangan") ||
          (fromColumnName === "Yakunlangan" && toColumnName === "Yakunlangan") ||
          (fromColumnName === "Yakunlangan" && toColumnName === "Jarayonda")
        ) {
          isMoveAllowed = true;
        } else if (
          fromColumnName === "Yakunlangan" &&
          toColumnName === "Tasdiqlangan" &&
          card.is_checked === false
        ) {
          const result = await Swal.fire({
            title: "Tasdiqlash",
            text: "Topshiriq nazoratchi tomonidan tekshirilmagan. Uni tasdiqlamoqchimisiz ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ha",
            cancelButtonText: "Yo'q",
          });

          if (result.isConfirmed) {
            this.checkedByCreator = true;
            isMoveAllowed = true;
          }
        }
      } else if (userRole === "Ijro") {
        // Ijro: faqat Jarayonda (2) ↔ Yakunlangan (3)
        if (
          (fromColumnName === "Yangi topshiriqlar" &&
            toColumnName === "Jarayonda") ||
          (fromColumnName === "Jarayonda" &&
            toColumnName === "Yangi topshiriqlar") ||
          (fromColumnName === "Jarayonda" && toColumnName === "Yakunlangan") ||
          (fromColumnName === "Yakunlangan" && toColumnName === "Jarayonda") ||
          (fromColumnName === "Yangi topshiriqlar" &&
            toColumnName === "Yangi topshiriqlar") ||
          (fromColumnName === "Jarayonda" && toColumnName === "Jarayonda") ||
          (fromColumnName === "Yakunlangan" && toColumnName === "Yakunlangan")
        ) {
          isMoveAllowed = true;
        }
      } else if (userRole === "Rozilik") {
        // Rozilik: faqat Yangi topshiriqlar (1) ↔ Jarayonda (2)
        if (
          (fromColumnName === "Yangi topshiriqlar" &&
            toColumnName === "Jarayonda") ||
          (fromColumnName === "Jarayonda" &&
            toColumnName === "Yangi topshiriqlar")
        ) {
          isMoveAllowed = true;
        }
      } else if (userRole === "Malumot") {
        // Malumot: hech qayerga ko'chmasin
        isMoveAllowed = false;
      }

      if (isCardCreator && userRole == "Ijro") {
        isMoveAllowed = true;
      }

      // Agar ko'chirish ruxsat etilmasa, xato xabari ko'rsatish
      if (!isMoveAllowed) {
        this.showError("Ushbu toshiriqni quyidagi joyga ko‘chira olmaysiz!");
        this.columns[fromCol].cards.splice(fromIndex, 0, card); // Kartani orqaga qaytarish
        return;
      }

      // Ko'chirish ruxsat etilgan bo'lsa, kartani yangi ustunga qo'shish
      if (toIndex === null || toIndex === undefined) {
        this.columns[toCol].cards.push(card);
      } else {
        this.columns[toCol].cards.splice(toIndex, 0, card);
      }

      // Backend'ni yangilash
      this.updateTaskColumn(card.id, this.columns[toCol].id, this.checkedByCreator);
    },
    async updateTaskColumn(taskId, columnId) {
      // console.log('taskid:' + taskId, 'columnId:' + columnId);
      
      // Optimistically update the card's column_id locally
      this.columns.forEach(col => {
        const card = col.cards.find(c => c.id === taskId);
        if (card) card.column_id = columnId;
      });

      try {
        await api.patch("/task-update", {
          task_id: taskId,
          column_id: columnId,
        });
        console.log(`Task ${taskId} moved to column ${columnId}`);

        if (this.checkedByCreator === true) {
          await api.post("/task-comment-create", {
            task_id: taskId,
            message: 'Topshiriq nazoratchi tekshiruvisiz qabul qilindi'
          });
          this.checkedByCreator = false;
        }
      } catch (error) {
        console.error("Error updating task column:", error);
        this.showError("Vazifani yangilashda xatolik yuz berdi!");
        // If error occurs, we could technically revert, but a full fetch is safer here
        this.fetchTasks();
      }
      
      if (this.taskModal) {
        this.taskModal = false;
      }
    },
    addMember() {
      if (this.newMember.user_id && this.newMember.process) {
        this.selectedMembers.push({ ...this.newMember });
        this.newMember = { user_id: null, process: null };
      }
    },
    removeMember(index) {
      this.selectedMembers.splice(index, 1);
    },
    getEmployeeName(id) {
      const employee = this.employees.find((emp) => emp.id === id);
      return employee ? employee.name : "Unknown";
    },
    getEmployeeNameWithProcess(id, members) {
      // member ichidagi process nomini topish
      var memberProcess = members?.find((m) => m.user_id === id)?.process;

      if (memberProcess === "Rozilik") {
        memberProcess = "Nazorat/Rozilik";
      }

      return memberProcess;
    },
    getEmployeeAvatar(id) {
      const employee = this.employees.find((emp) => emp.id == id);
      return `https://api.task-board.uz/storage/user/avatar/${employee?.avatar || "user.png"}`;
    },
    hasAvatar(id) {
       const employee = this.employees.find((emp) => emp.id == id);
       return employee && employee.avatar && employee.avatar !== "user.png";
    },
    getInitials(fullName) {
       if (!fullName) return "";
       const parts = fullName.trim().split(" ");
       if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
       return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    },

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    handlePaste(event) {
      const items = event.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          const file = items[i].getAsFile();
          this.commentFile = file;
          this.fileName = file.name || "screenshot.png";
          this.previewUrl = URL.createObjectURL(file); // rasmni blob URL qilib olish
        }
      }
    },

    commentFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.commentFile = file;
        this.fileName = file.name;
        this.previewUrl = URL.createObjectURL(file);
      }
    },

    removeFile() {
      this.commentFile = null;
      this.fileName = "";
      this.previewUrl = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    async submitTask() {
      const hasExecutor = this.selectedMembers.some(
        (member) => member.process === "Ijro"
      );
      if (!hasExecutor) {
        Swal.fire({
          icon: "warning",
          title: "Diqqat!",
          text: "Ijro uchun xodim biriktiring",
          confirmButtonText: "Ok",
        });
        return;
      }

      let workspace_id = localStorage.getItem("current_workspace_id");
      if (workspace_id == 'undefined' || workspace_id == null) {
        Swal.fire({
          icon: "warning",
          title: "Diqqat!",
          text: "Loyiha tanlanmagan",
          confirmButtonText: "Ok",
        });
        return;
      }
      
      const formData = new FormData();
      formData.append("column_id", this.columns[0].id);
      formData.append("task_name", this.taskName);
      formData.append("task_description", this.taskDescription || null);
      if (this.file) {
        formData.append("file", this.file);
      }
      formData.append("members", JSON.stringify(this.selectedMembers));
      formData.append("task_deadline", this.taskDeadline || null);
      formData.append("project_id", workspace_id);

      try {
        await api.post(
          "/create-task",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        Swal.fire({
          icon: "success",
          title: "Yangi vazifa yaratildi",
          confirmButtonText: "Ok",
        });
        // this.createTaskDialog = false;
        // this.resetForm();
        await this.fetchTasks();
      } catch (error) {
        this.showError(error.response?.data?.errors?.task_deadline?.[0] || "Xato yuz berdi!");
      }
    },
    resetForm() {
      this.taskName = "";
      this.taskDescription = "";
      this.taskDeadline = "";
      this.file = null;
      this.selectedMembers = [];
      this.newMember = { user_id: null, process: null };
      this.taskDeadlineFormatted = null;
    },
  },
};
</script>

<style>
/* Frappe Gantt Default Styles */
:root{--g-arrow-color: #1f2937;--g-bar-color: #fff;--g-bar-border: #fff;--g-tick-color-thick: #ededed;--g-tick-color: #f3f3f3;--g-actions-background: #f3f3f3;--g-border-color: #ebeff2;--g-text-muted: #7c7c7c;--g-text-light: #fff;--g-text-dark: #171717;--g-progress-color: #dbdbdb;--g-handle-color: #37352f;--g-weekend-label-color: #dcdce4;--g-expected-progress: #c4c4e9;--g-header-background: #fff;--g-row-color: #fdfdfd;--g-row-border-color: #c7c7c7;--g-today-highlight: #37352f;--g-popup-actions: #ebeff2;--g-weekend-highlight-color: #f7f7f7}html[data-theme=dark]{--g-arrow-color: #e5e5e5;--g-bar-color: #2a2a2a;--g-bar-border: #3a3a3a;--g-tick-color-thick: #1a1a1a;--g-tick-color: #0a0a0a;--g-actions-background: #1a1a1a;--g-border-color: #2a2a2a;--g-text-muted: #999999;--g-text-light: #ffffff;--g-text-dark: #f5f5f5;--g-progress-color: #4a4a4a;--g-handle-color: #d0d0d0;--g-weekend-label-color: #3a3a3a;--g-expected-progress: #5a5a5a;--g-header-background: #0a0a0a;--g-row-color: #141414;--g-row-border-color: #2a2a2a;--g-today-highlight: #999999;--g-popup-actions: #1a1a1a;--g-weekend-highlight-color: #0f0f0f}.gantt-container{line-height:14.5px;position:relative;overflow:auto;font-size:12px;height:var(--gv-grid-height);width:100%;border-radius:8px;isolation:isolate}.gantt-container .popup-wrapper{position:absolute;top:0;left:0;background:var(--g-header-background);box-shadow:0 10px 24px -3px #0003;padding:10px;border-radius:5px;width:max-content;z-index:1000}.gantt-container .popup-wrapper .title{margin-bottom:2px;color:var(--g-text-dark);font-size:.85rem;font-weight:650;line-height:15px}.gantt-container .popup-wrapper .subtitle{color:var(--g-text-dark);font-size:.8rem;margin-bottom:5px}.gantt-container .popup-wrapper .details{color:var(--g-text-muted);font-size:.7rem}.gantt-container .popup-wrapper .actions{margin-top:10px;margin-left:3px}.gantt-container .popup-wrapper .action-btn{border:none;padding:5px 8px;background-color:var(--g-popup-actions);border-right:1px solid var(--g-border-color)}.gantt-container .popup-wrapper .action-btn:hover{filter:brightness(97%)}.gantt-container .popup-wrapper .action-btn:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px}.gantt-container .popup-wrapper .action-btn:last-child{border-right:none;border-top-right-radius:4px;border-bottom-right-radius:4px}.gantt-container .grid-header{height:calc(var(--gv-lower-header-height) + var(--gv-upper-header-height) + 10px);background-color:var(--g-header-background);position:sticky;top:0;left:0;border-bottom:1px solid var(--g-row-border-color);z-index:1000}.gantt-container .lower-text,.gantt-container .upper-text{text-anchor:middle}.gantt-container .upper-header{height:var(--gv-upper-header-height)}.gantt-container .lower-header{height:var(--gv-lower-header-height)}.gantt-container .lower-text{font-size:12px;position:absolute;width:calc(var(--gv-column-width) * .8);height:calc(var(--gv-lower-header-height) * .8);margin:0 calc(var(--gv-column-width) * .1);align-content:center;text-align:center;color:var(--g-text-muted)}.gantt-container .upper-text{position:absolute;width:fit-content;font-weight:500;font-size:14px;color:var(--g-text-dark);height:calc(var(--gv-lower-header-height) * .66)}.gantt-container .current-upper{position:sticky;left:0!important;padding-left:17px;background:var(--g-header-background)}.gantt-container .side-header{position:sticky;top:0;right:0;float:right;z-index:1000;line-height:20px;font-weight:400;width:max-content;margin-left:auto;padding-right:10px;padding-top:10px;background:var(--g-header-background);display:flex}.gantt-container .side-header *{transition-property:background-color;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s;background-color:var(--g-actions-background);border-radius:.5rem;border:none;padding:5px 8px;color:var(--g-text-dark);font-size:14px;letter-spacing:.02em;font-weight:420;box-sizing:content-box;margin-right:5px}.gantt-container .side-header *:last-child{margin-right:0}.gantt-container .side-header *:hover{filter:brightness(97.5%)}.gantt-container .side-header select{width:60px;padding-top:2px;padding-bottom:2px}.gantt-container .side-header select:focus{outline:none}.gantt-container .date-range-highlight{background-color:var(--g-progress-color);border-radius:12px;height:calc(var(--gv-lower-header-height) - 6px);top:calc(var(--gv-upper-header-height) + 5px);position:absolute}.gantt-container .current-highlight{position:absolute;background:var(--g-today-highlight);width:1px;z-index:999}.gantt-container .current-ball-highlight{position:absolute;background:var(--g-today-highlight);z-index:1001;border-radius:50%}.gantt-container .current-date-highlight{background:var(--g-today-highlight);color:var(--g-text-light);border-radius:5px}.gantt-container .holiday-label{position:absolute;top:0;left:0;opacity:0;z-index:1000;background:var(--g-weekend-label-color);border-radius:5px;padding:2px 5px}.gantt-container .holiday-label.show{opacity:100}.gantt-container .extras{position:sticky;left:0}.gantt-container .extras .adjust{position:absolute;left:8px;top:calc(var(--gv-grid-height) - 60px);background-color:var(--g-actions-background);color:var(--g-text-light);border:none;padding:8px;border-radius:3px}.gantt-container .hide{display:none}.gantt{user-select:none;-webkit-user-select:none;position:absolute}.gantt .grid-background{fill:none}.gantt .grid-row{fill:var(--g-row-color)}.gantt .row-line{stroke:var(--g-border-color)}.gantt .tick{stroke:var(--g-tick-color);stroke-width:.4}.gantt .tick.thick{stroke:var(--g-tick-color-thick);stroke-width:.7}.gantt .arrow{fill:none;stroke:var(--g-arrow-color);stroke-width:1.5}.gantt .bar-wrapper .bar{fill:var(--g-bar-color);stroke:var(--g-bar-border);stroke-width:0;transition:stroke-width .3s ease}.gantt .bar-progress{fill:var(--g-progress-color);border-radius:4px}.gantt .bar-expected-progress{fill:var(--g-expected-progress)}.gantt .bar-invalid{fill:transparent;stroke:var(--g-bar-border);stroke-width:1;stroke-dasharray:5}:is(.gantt .bar-invalid)~.bar-label{fill:var(--g-text-light)}.gantt .bar-label{fill:var(--g-text-dark);dominant-baseline:central;font-family:Helvetica;font-size:13px;font-weight:400}.gantt .bar-label.big{fill:var(--g-text-dark);text-anchor:start}.gantt .handle{fill:var(--g-handle-color);opacity:0;transition:opacity .3s ease}.gantt .handle.active,.gantt .handle.visible{cursor:ew-resize;opacity:1}.gantt .handle.progress{fill:var(--g-text-muted)}.gantt .bar-wrapper{cursor:pointer}.gantt .bar-wrapper .bar{outline:1px solid var(--g-row-border-color);border-radius:3px}.gantt .bar-wrapper:hover .bar{transition:transform .3s ease}.gantt .bar-wrapper:hover .date-range-highlight{display:block}.gantt .grid-column{fill:transparent;pointer-events:all}.gantt .grid-column:hover{fill:var(--g-weekend-highlight-color);transition:fill .1s ease}

/* Fix SweetAlert2 z-index to appear above TaskDialog modal */
.swal2-container {
  z-index: 999999 !important;
}
</style>

<style scoped>
/* Natural Shimmer Skeleton Loader */
.skeleton-box {
  background: linear-gradient(90deg, #e2e8f0 25%, #f8fafc 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 2s infinite linear;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

:root {
  --bg: #ffffff;
  --card-bg: #ffffff;
  --panel: #ffffff;
  --text: #0f172a;
  --muted: #64748b;
  --primary: #4f46e5;
  --primary-hover: #4338ca;
  --success: #059669;
  --success-hover: #047857;
  --danger: #e11d48;
  --danger-hover: #be123c;
  --border: #e5e7eb;
  --card-border: #d1d5db;
  --radius-xl: 18px;
  --radius-lg: 14px;
  --shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
  --shadow-lg: 0 10px 25px rgba(15, 23, 42, 0.12);
  --primary-subtle: #e0e7ff;
  --danger-subtle: #fee2e2;
  --add-btn-bg: #2563eb;
  --add-btn-hover: #1d4ed8;
}

/* === Layout === */
.board {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  color: var(--text);
  background: var(--bg);
  border-radius: 20px;
}

/* === Header === */
.board__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.board__title {
  font-size: 26px;
  font-weight: 800;
  color: black !important;
  margin: 0;
  background: linear-gradient(90deg, var(--primary), #6366f1);
}

.main-content {
    background-color: #f3f3f9 !important;
}

/* === Toolbar === */
.toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

/* === Inputs & buttons === */
.input {
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
  background: #fff;
  transition: 0.2s ease;
}

.input:focus {
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.2);
  border-color: var(--primary);
}

.input--search {
  width: 240px;
}

.input--title {
  width: 100%;
  font-weight: 600;
}

.input--full {
  width: 100%;
}

.not-allowed {
  cursor: not-allowed;
}

.btn {
  border: none;
  border-radius: 14px;
  padding: 10px 14px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow);
}

.btn:active {
  transform: scale(0.97);
}

.btn--success {
  background: var(--success);
  color: #fff;
}

.btn--success:hover {
  background: var(--success-hover);
}

.icon-btn--add {
  background: linear-gradient(135deg, var(--add-btn-bg), #3b82f6);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  padding: 8px;
  border-radius: 50%;
  border: none;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  margin-left: auto;
}

.icon-btn--add:hover {
  background: linear-gradient(135deg, var(--add-btn-hover), #2563eb);
  transform: translateY(-2px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.icon-btn--add:active {
  transform: scale(0.95);
}

.icon-btn--add .icon {
  display: inline-block;
  transform: translateY(-1px);
}

/* === Columns row === */
.columns {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  height: 80vh;
  margin: 15px 0;
}

/* === Column === */
.column {
  background: var(--panel);
  border-radius: 5px;
  box-shadow: var(--shadow);
  padding: 10px;
  background-color: var(--vz-topnav-bg);
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 250px;
  transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
  height: 80vh;
  overflow: hidden;
}

.column.collapsed {
  min-width: 50px;
  max-width: 50px;
  align-items: center;
  justify-content: flex-start;
}

.column.collapsed .column__title {
  writing-mode: vertical-rl; /* matnni vertikal qiladi */
  transform: rotate(180deg); /* yuqoridan pastga emas, pastdan yuqoriga */
  text-align: center;
  white-space: nowrap;
  font-size: 14px;
}

.column .cards {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.8s ease;
  min-width: 250px;
}

.column.collapsed .cards {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.column:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.column__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.column__title {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  cursor: text;
  flex: 1;
  line-height: 1.2;
  color: var(--primary);
}

.newtask {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

/* === Cards stack === */
.control-panel {
  cursor: auto !important;
  margin-bottom: 0!important;
  margin-top: 10px !important;
}

.cards {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-height: 665px;
  overflow-y: auto;
  min-height: 50px;
  transition: border 0.2s ease;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.cards::-webkit-scrollbar {
  display: none;
}

.drag-target-column {
  border: 2px dashed #000000;
  background: rgba(0, 0, 0, 0.1);
}

.card-wrapper {
  position: relative;
}

.cards .card {
  background-color: #f3f3f9;
}

.card {
  border: 1px solid var(--card-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  cursor: grab;
  user-select: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border 0.2s ease;
  margin: 4px 0;
  border-radius: 5px;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.card:active {
  cursor: grabbing;
}

.drag-source {
  border: 2px dashed #000000;
  background: rgba(0, 0, 0, 0.1);
}

.insertion-line {
  height: 4px;
  background: transparent;
  transition: background 0.2s ease;
  margin: 4px 0;
}

.insertion-line.active {
  background: #000000;
  border-top: 2px dashed #000000;
}

.card-body {
  padding: 12px 14px;
}

.d-flex {
  display: flex;
  align-items: center;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.fs-15 {
  font-size: 15px;
}

.mb-0 {
  margin-bottom: 0;
}

.flex-grow-1 {
  flex-grow: 1;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.task-title a {
  color: var(--text);
  text-decoration: none;
}

.task-title a:hover {
  text-decoration: underline;
}

.text-muted {
  color: var(--muted);
}

.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow);
  list-style: none;
  padding: 0.5rem 0;
  margin: 0;
  z-index: 1000;
  min-width: 120px;
}

.dropdown-item {
  display: block;
  padding: 0.25rem 1rem;
  color: var(--text);
  text-decoration: none;
  font-size: 14px;
}

.dropdown-item:hover {
  background: var(--primary-subtle);
  color: var(--primary);
}

.ri-more-fill,
.ri-eye-fill,
.ri-edit-2-line,
.ri-delete-bin-5-line {
  font-size: 16px;
  vertical-align: middle;
}

.align-bottom {
  vertical-align: bottom;
}

.me-2 {
  margin-right: 0.5rem;
}

.text-secondary {
  color: #6b7280;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.progress {
  height: 6px;
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
}

.progress-sm {
  height: 4px;
}

.progress-bar {
  background: var(--danger);
  transition: width 0.3s ease;
  height: 4px;
}

.bg-primary-subtle {
  background: var(--primary-subtle);
}

.text-primary {
  color: var(--primary);
}

.badge {
  padding: 0.25em 0.4em;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  display: inline-block;
}

.avatar-group {
  display: flex;
  align-items: center;
  justify-content: end;
}

.avatar-group-item {
  margin-left: -8px!important;
  border: 2px solid var(--card-bg);
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.avatar-group-item:hover {
  transform: translateY(-2px);
}

.avatar-xxs {
  width: 24px;
  height: 24px;
}

.rounded-circle {
  border-radius: 50%;
}

.material-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.empty {
  color: var(--muted);
  font-size: 13px;
  font-style: italic;
  text-align: center;
  padding: 8px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsiv */
@media (max-width: 1200px) {
  .column {
    min-width: 200px;
    max-width: 270px;
  }
}

@media (max-width: 768px) {
  .board__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .toolbar {
    width: 100%;
  }

  .input--search {
    width: 100%;
  }

  .column {
    min-width: 180px;
    max-width: 220px;
  }

  .cards {
    max-height: 400px;
  }
}

.multi-line-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* nechta qator ko‘rinsin */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-body {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.modal-body::-webkit-scrollbar {
  display: none;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-dialog {
  width: 1300px;
}

.custom_btn {
  border-radius: 0px;
}

.custom_card {
  border: none;
  background-color: #f3f3f9;
  border-radius: 7px;
}

.container-1 {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}

.file-name {
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
}

.task-file-chip {
  display: inline-flex;
  align-items: center;
  background: rgba(99, 102, 241, 0.06);
  border: 1px solid rgba(99, 102, 241, 0.15);
  border-radius: 20px;
  padding: 3px 10px 3px 4px;
  cursor: pointer;
  max-width: 100%;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.task-file-chip:hover {
  background: rgba(99, 102, 241, 0.12);
  border-color: rgba(99, 102, 241, 0.3);
  transform: translateY(-1px);
}
.task-file-chip .file-icon-bg {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #818cf8);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  font-size: 10px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.25);
}
.task-file-chip .file-chip-info {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  flex-grow: 1;
}
.task-file-chip .file-chip-name {
  font-size: 11px;
  font-weight: 600;
  color: #4f46e5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}
.task-file-chip .file-chip-count {
  font-size: 9.5px;
  font-weight: 700;
  background: white;
  color: #6366f1;
  padding: 1px 5px;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
}
.task-file-chip .download-icon {
  margin-left: 6px;
  font-size: 11px;
  color: #818cf8;
  transition: color 0.2s;
  opacity: 0.8;
}
.task-file-chip:hover .download-icon {
  color: #4f46e5;
  opacity: 1;
}

.comments-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}

/* Custom Task Checkbox */
.card-selection-wrapper {
  opacity: 0;
  transition: opacity 0.2s ease;
}
.card:hover .card-selection-wrapper,
.card-selection-wrapper.is-selected {
  opacity: 1;
}
.custom-task-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.custom-task-checkbox:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}
.custom-task-checkbox.checked {
  background: #3b82f6;
  border-color: #3b82f6;
  color: white;
}
.custom-task-checkbox i {
  font-size: 9px;
  display: none;
}
.custom-task-checkbox.checked i {
  display: block;
}

/* Header Select All Checkbox Styling */
.header-selection-check {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.header-selection-check:hover {
  border-color: #405189;
}
.header-selection-check.checked {
  background: #405189;
  border-color: #405189;
  color: white;
}
.header-selection-check i {
  font-size: 9px;
  display: none;
}
.header-selection-check.checked i {
  display: block;
}

.comment-item {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}

.comment-item.other {
  justify-content: flex-start;
  flex-direction: row;
  /* avatar chapda */
}

.comment-item.me {
  flex-direction: row-reverse;
  /* avatar o‘ngda */
}

.comment-avatar {
  width: 30px;
  height: 40px;
  border-radius: 40%;
  object-fit: cover;
}

.comment-bubble {
  border-radius: 12px;
  padding: 5px 10px;
  max-width: 70%;
  word-wrap: break-word;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: var(--vz-body-bg);
}

.comment-item.me .comment-bubble {
  text-align: right;
}

.comment-message {
  font-size: 14px;
  margin: 5px 0;
}

.comment-file a {
  color: #1976d2;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
}

.comment-file a:hover {
  text-decoration: underline;
}

.comment-time {
  font-size: 11px;
  color: #777;
  margin-top: 5px;
  text-align: right;
}

.v-expansion-panel-text__wrapper {
  padding: 0px 10px 12px !important;
}

.v-expansion-panel__shadow {
  box-shadow: none !important;
}

.v-card {
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bg-dark-red {
  background-color: red;
}

.deadline-days {
  top: -7px;
  left: 5px;
}

.bg-danger1 {
  background-color: red;
}

.custom-context-menu {
  position: absolute;
  background: #fff;
  border-radius: 8px;
  min-width: 120px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 99999 !important;
}

.custom-context-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.custom-context-menu li {
  padding: 8px 15px;
  cursor: pointer;
  font-size: 12px;
  z-index: 9999 !important;
}

.custom-context-menu li:hover {
  background: #f5f5f5;
  border-radius: 8px;
}

.slide-up-enter-active {
  transition: all 0.25s ease-out;
}

.slide-up-leave-active {
  transition: all 0.2s ease-in;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(10px);
  /* pastdan chiqadi */
}

.slide-up-enter-to,
.slide-up-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.v-expansion-panel-title {
  background-color: #f3f3f9;
  /* yoki hover rangingiz */
  transition: background-color 0.2s;
}

[data-bs-theme="dark"] .v-expansion-panel-title {
  background-color: #091124ed !important;
}

/* From Uiverse.io by Galahhad */
/* The design is inspired from the mockapi.io */

.popup {
  --burger-line-width: 1.125em;
  --burger-line-height: 0.125em;
  --burger-offset: 0.625em;
  --burger-bg: rgba(0, 0, 0, 0.15);
  --burger-color: #333;
  --burger-line-border-radius: 0.1875em;
  --burger-diameter: 2.125em;
  --burger-btn-border-radius: calc(var(--burger-diameter) / 2);
  --burger-line-transition: 0.3s;
  --burger-transition: all 0.1s ease-in-out;
  --burger-hover-scale: 1.1;
  --burger-active-scale: 0.95;
  --burger-enable-outline-color: var(--burger-bg);
  --burger-enable-outline-width: 0.125em;
  --burger-enable-outline-offset: var(--burger-enable-outline-width);
  /* nav */
  --nav-padding-x: 0.25em;
  --nav-padding-y: 0.625em;
  --nav-border-radius: 0.375em;
  --nav-border-color: #ccc;
  --nav-border-width: 0.0625em;
  --nav-shadow-color: rgba(0, 0, 0, 0.2);
  --nav-shadow-width: 0 1px 5px;
  --nav-bg: #eee;
  --nav-font-family: Menlo, Roboto Mono, monospace;
  --nav-default-scale: 0.8;
  --nav-active-scale: 1;
  --nav-position-left: 0;
  --nav-position-right: unset;
  /* if you want to change sides just switch one property */
  /* from properties to "unset" and the other to 0 */
  /* title */
  --nav-title-size: 0.625em;
  --nav-title-color: #777;
  --nav-title-padding-x: 1rem;
  --nav-title-padding-y: 0.25em;
  /* nav button */
  --nav-button-padding-x: 1rem;
  --nav-button-padding-y: 0.375em;
  --nav-button-border-radius: 0.375em;
  --nav-button-font-size: 12px;
  --nav-button-hover-bg: #6495ed;
  --nav-button-hover-text-color: #fff;
  --nav-button-distance: 0.875em;
  /* underline */
  --underline-border-width: 0.0625em;
  --underline-border-color: #ccc;
  --underline-margin-y: 0.3125em;
}

/* popup settings 👆 */

.popup {
  display: inline-block;
  text-rendering: optimizeLegibility;
  position: relative;
  z-index: 1;
  margin: 0;
  user-select: none;
  /* pointer-events: none; */
}

.popup input {
  display: none;
}

.burger {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background: var(--burger-bg);
  width: var(--burger-diameter);
  height: var(--burger-diameter);
  border-radius: var(--burger-btn-border-radius);
  border: none;
  cursor: pointer;
  overflow: hidden;
  transition: var(--burger-transition);
  outline: var(--burger-enable-outline-width) solid transparent;
  outline-offset: 0;
}

.burger span {
  height: var(--burger-line-height);
  width: var(--burger-line-width);
  background: var(--burger-color);
  border-radius: var(--burger-line-border-radius);
  position: absolute;
  transition: var(--burger-line-transition);
}

[data-bs-theme="dark"] .burger span {
  background-color: white !important;
}

.burger span:nth-child(1) {
  top: var(--burger-offset);
}

.burger span:nth-child(2) {
  bottom: var(--burger-offset);
}

.burger span:nth-child(3) {
  top: 50%;
  transform: translateY(-50%);
}

.popup-window {
  transform: scale(var(--nav-default-scale));
  visibility: hidden;
  opacity: 0;
  position: absolute;
  padding: var(--nav-padding-y) var(--nav-padding-x);
  background: var(--nav-bg);
  font-family: var(--nav-font-family);
  color: var(--nav-text-color);
  border-radius: var(--nav-border-radius);
  box-shadow: var(--nav-shadow-width) var(--nav-shadow-color);
  border: var(--nav-border-width) solid var(--nav-border-color);
  top: calc(var(--burger-diameter) + var(--burger-enable-outline-width) + var(--burger-enable-outline-offset));
  left: var(--nav-position-left);
  right: var(--nav-position-right);
  transition: var(--burger-transition);
}

.popup-window legend {
  padding: var(--nav-title-padding-y) var(--nav-title-padding-x);
  margin: 0;
  color: var(--nav-title-color);
  font-size: var(--nav-title-size);
  text-transform: uppercase;
}

.popup-window ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.popup-window ul li:hover .hover-color {
  color: white!important;
}

.popup-window ul button {
  outline: none;
  width: 100%;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  color: var(--burger-color);
  font-size: var(--nav-button-font-size);
  padding: var(--nav-button-padding-y) var(--nav-button-padding-x);
  white-space: nowrap;
  border-radius: var(--nav-button-border-radius);
  cursor: pointer;
  column-gap: var(--nav-button-distance);
}

.popup-window ul li:nth-child(1) svg,
.popup-window ul li:nth-child(2) svg {
  color: cornflowerblue;
}

.popup-window ul li:nth-child(4) svg,
.popup-window ul li:nth-child(5) svg {
  color: rgb(153, 153, 153);
}

.popup-window ul li:nth-child(7) svg {
  color: red;
}

.popup-window hr {
  margin: var(--underline-margin-y) 0;
  border: none;
  border-bottom: var(--underline-border-width) solid var(--underline-border-color);
}

/* actions */

.popup-window ul button:hover,
.popup-window ul button:focus-visible,
.popup-window ul button:hover svg,
.popup-window ul button:focus-visible svg {
  color: var(--nav-button-hover-text-color);
  background: var(--nav-button-hover-bg);
}

.burger:hover {
  transform: scale(var(--burger-hover-scale));
}

.burger:active {
  transform: scale(var(--burger-active-scale));
}

.burger:focus:not(:hover) {
  outline-color: var(--burger-enable-outline-color);
  outline-offset: var(--burger-enable-outline-offset);
}

.popup input:checked+.burger span:nth-child(1) {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.popup input:checked+.burger span:nth-child(2) {
  bottom: 50%;
  transform: translateY(50%) rotate(-45deg);
}

.popup input:checked+.burger span:nth-child(3) {
  transform: translateX(calc(var(--burger-diameter) * -1 - var(--burger-line-width)));
}

.popup input:checked~nav {
  transform: scale(var(--nav-active-scale));
  visibility: visible;
  opacity: 1;
}

.search-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.file-preview {
  width: 70px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  flex-direction: column;
}

.image-controls {
  position: absolute;
  top: 20px;
  right: 30px;
  display: flex;
  gap: 12px;
  z-index: 3;
}

.image-controls button,
.image-controls a {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s;
}

.image-controls button:hover,
.image-controls a:hover {
  background: rgba(255, 255, 255, 0.4);
}

.zoomable-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
  transition: transform 0.3s ease;
  cursor: grab;
}

.pdf-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  flex-direction: column;
}

.pdf-controls {
  position: absolute;
  top: 20px;
  right: 30px;
  display: flex;
  gap: 12px;
}

.pdf-controls button,
.pdf-controls a {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s;
}

.pdf-controls button:hover,
.pdf-controls a:hover {
  background: rgba(255, 255, 255, 0.4);
}

@media (min-width: 992px) {
  #sidebar {
    display: block !important;
  }

  .main-content {
    margin-left: 270px;
  }
}

#sidebar {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  background-color: #ffffff !important;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.04);
  border-right: 1px solid rgba(226, 232, 240, 0.6);
}

#sidebar.d-none {
  transform: translateX(-100%);
}

aside {
  padding: 1.5rem 1.25rem;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 85vh;
}

aside::-webkit-scrollbar {
  width: 5px;
}
aside::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.sidebar-menu h3 {
  margin-bottom: 1.2rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.02em;
}

.sidebar-menu ul {
  list-style: none;
  padding: 0;
}

.sidebar-menu ul li {
  margin-bottom: 0.35rem;
  cursor: pointer;
}

.sidebar-menu ul li a,
.all-projects {
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 10px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  color: #64748b;
  font-weight: 600;
  font-size: 14px;
  user-select: none;
  background-color: transparent;
  position: relative;
  overflow: hidden;
}

.all-projects {
  margin-bottom: 0.75rem;
  cursor: pointer;
}

.sidebar-menu ul li a:hover,
.all-projects:hover {
  color: #4f46e5;
  background-color: rgba(79, 70, 229, 0.05);
  transform: translateX(4px);
}

.project-thumbtack {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  color: #94a3b8;
  opacity: 0.5;
  transition: all 0.2s;
}
.sidebar-menu ul li a:hover .project-thumbtack {
  opacity: 1;
  color: #4f46e5;
}

.project-thumbtack i {
  transform: rotate(45deg);
}

.project-index {
  min-width: 24px;
  text-align: center;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-index span {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: inherit;
}

.sidebar-menu ul li a i, .all-projects i {
  margin-right: 12px;
  width: 20px;
  text-align: center;
  font-size: 16px;
  color: #94a3b8;
  transition: all 0.3s ease;
}

/* Premium Active State */
.sidebar-menu li.active a,
.all-projects.active {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #ffffff !important;
  transform: translateX(4px);
  box-shadow: 0 8px 16px rgba(99, 102, 241, 0.25);
}

/* Icon Color for Active */
.sidebar-menu li.active a i,
.all-projects.active i,
.sidebar-menu li.active a .project-index span {
  color: #ffffff !important;
}

/* Hover on active state (keep it solid) */
.sidebar-menu li.active a:hover,
.all-projects.active:hover {
  transform: translateX(4px) scale(1.02);
  background: linear-gradient(135deg, #4338ca, #6d28d9);
  box-shadow: 0 10px 20px rgba(99, 102, 241, 0.3);
}

/* Elegant glowing indicator */
.sidebar-menu li.active a::before,
.all-projects.active::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 15%;
  height: 70%;
  width: 4px;
  background-color: #ffffff;
  border-radius: 4px;
  opacity: 0.8;
}

.nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 10px;
  font-size: 12px;
}

.nav-link i {
  margin-right: 5px;
  font-size: 13px;
}

 .nav-item {
  border-bottom: 1px solid #eee;
 }

 .chart-card {
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: all 0.3s ease;
  margin: 15px 0;
}

.chart-card:hover {
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
}

.chart-header {
  padding: 20px 24px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.chart-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: -0.3px;
}

.zoom-controls {
  display: flex;
  gap: 8px;
}

.zoom-btn {
  background: #f5f5f5;
  color: #555;
  border: none;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  min-width: 60px;
}

.zoom-btn:hover {
  background: #e3f2fd;
  color: #1976d2;
  transform: translateY(-1px);
}

.zoom-btn.active {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(30, 136, 229, 0.3);
  transform: translateY(-1px);
}

.chart-container {
  height: 600px;
  padding: 16px 0;
}

/* Custom scrollbar for navigator */
.highcharts-scrollbar {
  margin: 0 16px;
}

.highcharts-scrollbar-track {
  background: #f0f0f0 !important;
  border-radius: 8px;
}

.highcharts-scrollbar-thumb {
  background: #1e88e5 !important;
  border-radius: 8px;
  opacity: 1 !important;
  box-shadow: 0 2px 6px rgba(30, 136, 229, 0.3);
}

.highcharts-scrollbar-thumb:hover {
  background: #1565c0 !important;
}

/* Tooltip arrow */
.highcharts-tooltip > span {
  padding: 12px 16px !important;
  border-radius: 8px !important;
}

/* Responsive */
@media (max-width: 768px) {
  .chart-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .zoom-controls {
    justify-content: center;
  }

  .zoom-btn {
    flex: 1;
  }
}
.calendar-container {
  width: 100%;
  max-width: none;
  margin: 15px 0;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.06);
  padding: 0;               /* FullCalendar ichida padding beramiz emas */
  overflow: hidden;        /* tashqi scroll yo'q */
  display: flex;
  flex-direction: column;
  /* kerak bo'lsa oynaga nisbatan balandlik: */
  max-height: 80vh;        /* yoki height: calc(100vh - 120px); */
  height: 80vh;
}

/* FullCalendar to'liq flex container bo'lsin */
.fc {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Header (toolbar) joyida turishi uchun sticky */
.fc .fc-header-toolbar,
.fc .fc-toolbar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;            /* header fonini oq qiling, orqa elementlar ko'rinmasligi uchun */
  border-bottom: 1px solid #eee;
  padding: 12px 16px;         /* toolbar ichidagi bo'shliq */
  box-shadow: 0 1px 0 rgba(0,0,0,0.02);
}

/* Haftaning nomlari/ day names ham pastga skroll bo'lmasligi uchun */
.fc .fc-col-header {
  position: sticky;
  top: 56px; /* toolbar balandligiga moslang (toolbar ~56px) */
  z-index: 9;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

/* View harness — body qismi scroll bo'lsin */
.fc .fc-view-harness,
.fc .fc-scroller {
  /* FullCalendar ichida eventlar va kunlar shu elementlarda joylashadi.
     Bizga kerak: shu qism scroll bo'lsin. */
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
}

/* Agar dayGrid ichidagi kunlar to'plami uchun qo'shimcha: */
.fc .fc-daygrid-body {
  /* ichki konteynerning minimal balandligi */
  min-height: 300px;
}

/* Scrollbar styling (ixtiyoriy) */
.fc .fc-view-harness::-webkit-scrollbar,
.fc .fc-scroller::-webkit-scrollbar {
  width: 8px;
}
.fc .fc-view-harness::-webkit-scrollbar-thumb,
.fc .fc-scroller::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(0,0,0,0.12);
}

/* Responsive: kichik ekranlarda balandlikni kamaytirish */
@media (max-width: 768px) {
  .calendar-container {
    height: 70vh;
    max-height: 70vh;
  }
  .fc .fc-header-toolbar,
  .fc .fc-toolbar {
    padding: 8px 12px;
  }
  .fc .fc-col-header {
    top: 48px; /* toolbar balandligiga moslab o'zgartiring */
  }
}
.performance-table {
  padding: 15px 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.toolbar button {
  padding: 6px 10px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
}

.toolbar input {
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.ag-theme-alpine .ag-row-hover {
  background-color: #f5f5f5 !important;
}

.ag-theme-alpine .ag-row-selected {
  background-color: #e3f2fd !important;
}


/* From Uiverse.io by Galahhad */ 
/* checkbox settings 👇 */

.ui-checkbox {
  --primary-color: #1677ff;
  --secondary-color: #fff;
  --primary-hover-color: #4096ff;
  /* checkbox */
  --checkbox-diameter: 20px;
  --checkbox-border-radius: 5px;
  --checkbox-border-color: #d9d9d9;
  --checkbox-border-width: 1px;
  --checkbox-border-style: solid;
  /* checkmark */
  --checkmark-size: 1.2;
}

.ui-checkbox, 
.ui-checkbox *, 
.ui-checkbox *::before, 
.ui-checkbox *::after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.ui-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* width: var(--checkbox-diameter);
  height: var(--checkbox-diameter); */
  width: 17px;
  height: 17px;
  border-radius: var(--checkbox-border-radius);
  background: var(--secondary-color);
  border: var(--checkbox-border-width) var(--checkbox-border-style) var(--checkbox-border-color);
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

.ui-checkbox::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-box-shadow: 0 0 0 calc(var(--checkbox-diameter) / 2.5) var(--primary-color);
  box-shadow: 0 0 0 calc(var(--checkbox-diameter) / 2.5) var(--primary-color);
  border-radius: inherit;
  opacity: 0;
  -webkit-transition: all 0.5s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  -o-transition: all 0.5s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  transition: all 0.5s cubic-bezier(0.12, 0.4, 0.29, 1.46);
}

.ui-checkbox::before {
  top: 40%;
  left: 50%;
  content: "";
  position: absolute;
  width: 4px;
  height: 7px;
  border-right: 2px solid var(--secondary-color);
  border-bottom: 2px solid var(--secondary-color);
  -webkit-transform: translate(-50%, -50%) rotate(45deg) scale(0);
  -ms-transform: translate(-50%, -50%) rotate(45deg) scale(0);
  transform: translate(-50%, -50%) rotate(45deg) scale(0);
  opacity: 0;
  -webkit-transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),opacity 0.1s;
  -o-transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),opacity 0.1s;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),opacity 0.1s;
}
/* actions */

.ui-checkbox:hover {
  border-color: var(--primary-color);
}

.ui-checkbox:checked {
  background: var(--primary-color);
  border-color: transparent;
}

.ui-checkbox:checked::before {
  opacity: 1;
  -webkit-transform: translate(-50%, -50%) rotate(45deg) scale(var(--checkmark-size));
  -ms-transform: translate(-50%, -50%) rotate(45deg) scale(var(--checkmark-size));
  transform: translate(-50%, -50%) rotate(45deg) scale(var(--checkmark-size));
  -webkit-transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  -o-transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
}

.ui-checkbox:active:not(:checked)::after {
  -webkit-transition: none;
  -o-transition: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  transition: none;
  opacity: 1;
}

.subtask-wrapper {
  margin-top: 8px;
}

.subtask-actions {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 12px;
  border: 1px dashed var(--primary, #1976d2);
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
  color: var(--primary, #1976d2);
  background: rgba(25, 118, 210, 0.03);
}

.subtask-actions:hover {
  background: rgba(25, 118, 210, 0.08);
}

.icon-container {
  position: relative;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.link-icon,
.right-icon,
.down-icon {
  position: absolute;
  font-size: 1.1em;
  transition: opacity 0.25s ease;
}

.link-icon {
  opacity: 1;
}

.right-icon,
.down-icon {
  opacity: 0;
}

.subtask-actions:hover .link-icon {
  opacity: 0;
}

.subtask-actions:hover .right-icon {
  opacity: 1;
}

.subtask-actions.active .link-icon,
.subtask-actions.active .right-icon {
  opacity: 0;
}

.subtask-actions.active .down-icon {
  opacity: 1;
}

.label {
  font-weight: 500;
  flex-grow: 1;
}

/* .add-btn {
  padding: 2px 10px;
  font-size: 0.85em;
  background: rgba(25, 118, 210, 0.1);
  border: 1px solid var(--primary, #1976d2);
  border-radius: 4px;
  color: var(--primary, #1976d2);
  cursor: pointer;
}

.add-btn:hover {
  background: rgba(25, 118, 210, 0.2);
} */

.breadcrumb {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--task-text-muted);
  margin-bottom: 0;
}

/* Kengaygan qism */
.subtask-content {
  margin-top: 8px;
  padding: 0 0 0 12px;
  animation: fadeIn 0.3s ease;
}

.subtask-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subtask-card {
  padding: 10px 14px;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.9em;
}

.no-subtask {
  padding: 5px;
  text-align: center;
  color: #777;
  font-style: italic;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.subtask-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}
.subtask-compact-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #3b82f6;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  animation: fadeIn 0.2s ease;
}
.subtask-compact-item:hover {
  background: #ffffff;
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
  transform: translateY(-1px);
}
.subtask-compact-left {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  overflow: hidden;
}
.subtask-compact-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.subtask-compact-title {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.subtask-id {
  color: #878a99;
  font-weight: 500;
  margin-right: 4px;
}
.subtask-compact-desc {
  font-size: 11px;
  color: #878a99;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.subtask-compact-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.subtask-compact-badges {
  display: flex;
  gap: 4px;
}
.compact-badge {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}
.compact-badge.in-progress {
  background: #fee2e2;
  color: #ef4444;
}
.compact-badge.done {
  background: #d1fae5;
  color: #059669;
}
.compact-badge.date {
  background: #fee2e2;
  color: #ef4444;
}
.subtask-compact-users {
  display: flex;
  align-items: center;
}
.compact-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid #fff;
  margin-left: -6px;
  object-fit: cover;
}
.compact-avatar:first-child {
  margin-left: 0;
}
.compact-avatar-more {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid #fff;
  margin-left: -6px;
  background: #f3f6f9;
  color: #405189;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subtask-role-badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.role-creator {
  background: rgba(10, 179, 156, 0.15);
  color: #0ab39c;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border-bottom-left-radius: 6px;
  display: flex;
  align-items: center;
  gap: 3px;
}
.role-assignee {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border-bottom-left-radius: 6px;
  display: block;
}

.avatar-badge {
  width: 27px;
  height: 25px;
  border-radius: 50%;
  background: #6c5ce7;
  color: white;
  font-size: 0.6rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.3);
}

.date-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px; /* pill */
  font-size: 0.75rem;
  line-height: 1;
  white-space: nowrap;
  background: rgba(255, 99, 71, 0.12); /* soft red */
  border: 1px solid rgba(255, 99, 71, 0.35);
  color: #e74c3c;
}
/* 
.date-badge.deadline {
  background: rgba(255, 99, 71, 0.12);
  border: 1px solid rgba(255, 99, 71, 0.35);
  color: #e74c3c;
}

.date-badge.deadline i {
  font-size: 0.8rem;
  color: #e74c3c;
} */

.priority-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 500;
}

.priority-badge.urgent {
  background: rgba(231, 76, 60, 0.2);
  color: #e74c3c;
  border: 1px solid rgba(231, 76, 60, 0.4);
}

/* Agar subtask bo'limini bosiladigan qilmoqchi bo'lsangiz */
.subtask-section.clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}

.subtask-section.clickable:hover {
  background: rgba(255, 255, 255, 0.08);
}

.subtask-section.clickable.active {
  background: rgba(255, 255, 255, 0.12);
  border-style: solid;
}

.subtask-form {
  position: relative;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px dashed rgba(108, 92, 231, 0.4);
  cursor: pointer;
}

.subtask-input {
  width: 70%;
  padding: 4px;
  font-size: 13px;
  /* border: 1px solid #e2e8f0; */
  border-radius: 4px;
  background: #fafbfc;
  transition: all 0.2s;
}

.subtask-input:focus {
  outline: none;
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.15);
  background: white;
}

.subtask-input::placeholder {
  color: #94a3b8;
}

.subtask-options {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
  flex-direction: column;
}

.option-btn {
  flex: 1;
  min-width: 100px;
  padding: 5px 10px;
  font-size: 13.5px;
  color: #64748b;
  background: #f1f5f9;
  border: none;
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.option-btn:hover {
  background: #e2e8f0;
  transform: translateY(-1px);
}

.save-area {
  text-align: right;
  position: absolute;
  top: 10px;
  right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.save-btn {
  padding: 5px 15px;
  font-size: 10px;
  font-weight: 500;
  color: white;
  background: #3b82f6;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
  transition: all 0.2s;
}

.save-btn:hover {
  background: #2563eb;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.close-btn {
  width: 28px;
  height: 28px;
  font-size: 15px;
  line-height: 1;
  color: #6b7280;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
}

.close-btn:hover {
  background: #fee2e2;
  color: #dc2626;
}

.option-modal {
  position: absolute;
  width: 95%;
  /* min-height: 200px; */
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 9999!important;
  margin-bottom: 25px;
}

.subtask-assignee-section {
  padding: 8px 12px;
  font-size: 14px;
}

.subtask-assignee-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.subtask-checkbox {
  margin: 0;
  transform: scale(0.9);
}

.subtask-assignee-form {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.subtask-assignee-autocomplete {
  flex: 1 1 220px;
  min-width: 180px;
}

.subtask-process-select {
  flex: 1 1 140px;
  min-width: 140px;
}

.subtask-add-btn {
  margin-top: 2px;
  min-width: 80px;
}

/* Tanlangan xodimlar */
.subtask-selected-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #444;
}

.subtask-member-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 160px;
  overflow-y: auto;
  padding-right: 4px;
}

.subtask-member-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 6px;
  background: #f8f9fa;
  transition: background 0.12s;
}

.subtask-member-item:hover {
  background: #f0f2f5;
}

.subtask-member-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.subtask-member-info {
  flex: 1;
  min-width: 0;
}

.subtask-member-name {
  font-weight: 500;
  font-size: 13.5px;
  display: block;
}

.subtask-member-process {
  font-size: 12px;
  color: #666;
  display: block;
}

.subtask-remove-btn {
  margin-left: auto;
}

.subtask-no-members {
  text-align: center;
  color: #888;
  font-size: 13px;
  padding: 16px 0;
  font-style: italic;
}

/* Vuetify override (agar kerak bo‘lsa) */
:deep(.v-field--outlined .v-field__outline) {
  --v-field-border-opacity: 0.22;
}

:deep(.v-chip.subtask-selected-chip) {
  font-size: 12px !important;
  height: 24px !important;
}
.assignee-avatars-only {
  display: flex;
  align-items: center;
  padding-left: 8px;
}

.assignee-avatar-sm {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2.3px solid #fff;
  object-fit: cover;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.assignee-more-sm {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #475569;
  color: white;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2.3px solid #fff;
}


.toggle-buttons {
  position: relative;
  display: flex;
  background: #f1f5f9;
  border-radius: 8px;          /* yumaloq emas, ozgina radius */
  overflow: hidden;
  margin-bottom: 16px;
  height: 38px;                /* biroz pastroq qildik */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.toggle-btn {
  flex: 1;
  background: transparent;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  z-index: 2;
  transition: color 0.25s ease;
}

.toggle-btn.active {
  color: white;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  border-radius: 8px;          /* tugmalar bilan mos radius */
  transition: transform 0.35s ease;
  z-index: 1;
}

/* Forma bloki — ixchamroq */
.form-content {
  background: white;
  border-radius: 8px;
  padding: 8px;               /* oldingidan kamroq padding */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

/* Forma elementlari */
.search-form {
  display: flex;
  flex-direction: column;
  gap: 10px;                   /* oralaridagi bo‘shliq kamaytirildi */
}

.search-form input,
.search-form select.custom-select {
  padding: 5px 10px;           /* balandlik qisqartirildi */
  border: 1px solid #cbd5e1;
  border-radius: 6px;          /* yumaloq emas, ozgina yumaloq */
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background-color: white;
}

.search-form input:focus,
.search-form select.custom-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.search-form button {
  padding: 9px;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: white;
  border: none;
  border-radius: 6px;          /* inputlar bilan bir xil radius */
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.search-form button:hover {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  box-shadow: 0 3px 10px rgba(59, 130, 246, 0.25);
}

/* Animatsiya */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.35s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

.structure-warning {
  margin-top: 10px;
  padding: 10px;
  border-left: 4px solid #f59e0b;
  background-color: #fff7ed;
  color: #92400e;
  font-size: 14px;
  border-radius: 6px;
}

.warning-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
/* 
.structure-link {
  color: #b45309;
  font-weight: 600;
  text-decoration: none;
}

.structure-link:hover {
  text-decoration: underline;
} */

.sidebar-title {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #94a3b8;
  margin: 24px 0 12px;
  padding: 0 12px;
}

/* MODERN MODAL STYLES */
.modern-modal {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.12);
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.modern-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  background: linear-gradient(to right, #f8fafc, #ffffff);
  border-bottom: 1px solid #e2e8f0;
}

.modern-modal-title {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.25);
}

.modern-modal-title h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}

.modern-modal-title p {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
}

.modern-modal-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modern-btn-outline {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 8px;
  border-color: #e2e8f0;
}

.modern-close-btn {
  background: #f1f5f9;
  color: #64748b;
  border-radius: 50%;
}

.modern-modal-body {
  padding: 0;
  background: #f8fafc;
}

.modern-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.modern-panel {
  padding: 32px;
  background: #ffffff;
}

.modern-panel-right {
  background: #f8fafc;
  border-left: 1px solid #e2e8f0;
}

.modern-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 24px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modern-form-group {
  margin-bottom: 24px;
}

.modern-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 8px;
}

.required-asterisk {
  color: #ef4444;
}

.modern-input, .modern-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fcfcfc;
  font-size: 14px;
  color: #1e293b;
  transition: all 0.2s ease;
}

.modern-input:focus, .modern-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  background: #ffffff;
}

.modern-file-upload {
  position: relative;
  width: 100%;
}

.modern-file-input {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  width: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.modern-file-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  background: #f8fafc;
  color: #64748b;
  transition: all 0.2s ease;
}

.modern-file-upload:hover .modern-file-dropzone {
  border-color: #3b82f6;
  background: #f1f5f9;
  color: #3b82f6;
}

.modern-file-dropzone.has-file {
  border-color: #10b981;
  background: #ecfdf5;
  color: #059669;
}

.modern-file-dropzone i {
  font-size: 28px;
}

.modern-file-dropzone span {
  font-size: 13px;
  font-weight: 500;
}

.modern-switch :deep(.v-switch__thumb) {
  background: white;
}
.modern-switch :deep(.v-switch__track) {
  opacity: 0.2;
}

.modern-process-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.modern-add-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 8px;
}

.modern-members-section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px dashed #cbd5e1;
}

.modern-badge {
  background: #e0e7ff;
  color: #4f46e5;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
}

.modern-members-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 4px;
}

.modern-members-list::-webkit-scrollbar {
  width: 4px;
}
.modern-members-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.modern-member-card {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  transition: all 0.2s ease;
}

.modern-member-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.modern-member-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
}

.modern-member-info {
  flex: 1;
}

.modern-member-info h5 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.modern-member-role {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.modern-remove-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #94a3b8;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.modern-remove-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}

.modern-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  color: #94a3b8;
  gap: 12px;
}

.modern-empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.modern-empty-state p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
}

.modern-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.modern-submit-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 10px;
}

.modern-cancel-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 10px;
}

/* Make it responsive */
@media (max-width: 900px) {
  .modern-grid-container {
    grid-template-columns: 1fr;
  }
  .modern-panel-right {
    border-left: none;
    border-top: 1px solid #e2e8f0;
  }
}

/* ------------------------------------- FullCalendar Custom Styling ------------------------------------- */
:deep(.calendar-container) {
  background: white;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-top: 1rem;
}
:deep(.fc-theme-standard td), :deep(.fc-theme-standard th) {
  border-color: #f1f5f9;
}
:deep(.fc .fc-toolbar-title) {
  font-size: 1.25em;
  font-weight: 700;
  color: #1e293b;
}
:deep(.fc-daygrid-event) {
  border-radius: 6px !important;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  border: none !important;
}
:deep(.fc-daygrid-event:hover) {
  transform: scale(1.02);
  z-index: 5;
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}
:deep(.custom-cal-event) {
  width: 100%;
  padding-bottom: 2px;
}

/* More Link "+ N yana" Styling */
:deep(.fc-daygrid-more-link) {
  display: block !important;
  margin: 2px !important;
  padding: 4px !important;
  background-color: #f1f5f9 !important; /* soft background */
  color: #3b82f6 !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-align: center !important;
  width: auto !important;
  border-radius: 4px !important;
  transition: all 0.2s ease !important;
  text-decoration: none !important;
}
:deep(.fc-daygrid-more-link:hover) {
  background-color: #e2e8f0 !important;
  color: #2563eb !important;
}
:deep(.fc-daygrid-day-bottom) {
  text-align: center !important;
  padding-bottom: 2px !important;
}

/* Enhancing the Popover */
:deep(.fc-popover) {
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15) !important;
  overflow: hidden;
  z-index: 9999 !important;
}
:deep(.fc-popover-header) {
  background: #f8fafc !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  padding: 10px !important;
}
:deep(.fc-popover-close) {
  opacity: 0.6;
  transition: opacity 0.2s;
}
:deep(.fc-popover-close:hover) {
  opacity: 1;
}

/* Enhancing Gantt View styling */
:deep(.chart-card) {
  background: white;
  border-radius: 16px;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-top: 1rem;
}
:deep(.chart-header) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
}
:deep(.zoom-controls .zoom-btn) {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 6px 14px;
  border-radius: 6px;
  margin-left: 8px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
}
:deep(.zoom-controls .zoom-btn.active), :deep(.zoom-controls .zoom-btn:hover) {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

/* Frappe Gantt Overrides */
:deep(.gantt .bar-new .bar-progress) { fill: #3b82f6 !important; }
:deep(.gantt .bar-new .bar) { fill: #eff6ff !important; stroke: #3b82f6 !important; stroke-width: 1.5; }

:deep(.gantt .bar-progress .bar-progress) { fill: #f59e0b !important; }
:deep(.gantt .bar-progress .bar) { fill: #fffbeb !important; stroke: #f59e0b !important; stroke-width: 1.5; }

:deep(.gantt .bar-done .bar-progress) { fill: #10b981 !important; }
:deep(.gantt .bar-done .bar) { fill: #ecfdf5 !important; stroke: #10b981 !important; stroke-width: 1.5; }

:deep(.gantt .bar-wrapper) {
  cursor: pointer;
  transition: transform 0.2s;
}
:deep(.gantt .bar-wrapper:hover) {
  transform: translateY(-2px);
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
}
/* ADVANCED FILTERS MODAL & BUTTON STYLES */
.advanced-filter-btn {
  border: 1px solid #e1e4e8;
  background: white;
  color: #495057;
  padding: 5px 12px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.advanced-filter-btn:hover {
  background: #f8f9fa;
  box-shadow: 0 4px 6px rgba(0,0,0,0.06);
}
.filter-count-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff5252;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  border: 2px solid white;
}
.active-filters-ribbon {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  align-items: center;
  max-height: 80px;
  overflow-y: auto;
}
.afr-chip {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}
.afr-chip i {
  margin-left: 6px;
  cursor: pointer;
  opacity: 0.7;
}
.afr-chip i:hover {
  opacity: 1;
}
.afr-clear {
  font-size: 12px;
  text-decoration: none;
  font-weight: 500;
}
.advanced-filter-overlay {
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease;
}
.advanced-filter-dialog {
  background: white;
  border-radius: 12px;
  width: 450px;
  max-width: 90vw;
  max-height: 95vh;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  overflow: hidden;
  animation: scaleUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
}
.afd-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f3f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.afd-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
}
.afd-close {
  background: #f8fafc;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  transition: all 0.2s;
}
.afd-close:hover {
  background: #e2e8f0;
  color: #0f172a;
}
.afd-body {
  padding: 24px;
  overflow-y: auto;
}
.afd-row label {
  display: block;
  font-weight: 500;
  font-size: 13px;
  color: #475569;
  margin-bottom: 6px;
}
.afd-row :deep(label) {
  margin-bottom: 0 !important;
}
.afd-date {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  font-size: 14px;
  color: #334155;
}
.afd-date:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.afd-footer {
  padding: 16px 24px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
}
.afd-btn-reset {
  background: white;
  border: 1px solid #cbd5e1;
  color: #475569;
  font-weight: 500;
  border-radius: 6px;
  padding: 8px 16px;
}
.afd-btn-apply {
  font-weight: 500;
  border-radius: 6px;
  padding: 8px 24px;
  box-shadow: 0 4px 6px rgba(59, 130, 246, 0.25);
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes scaleUp { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }

/* ========================================================= */
/* SPLIT BUTTON — Yangi topshiriq yaratish */
/* ========================================================= */
.create-task-split {
  display: inline-flex;
  align-items: stretch;
}
.create-task-split .split-main {
  border-radius: 5px 0 0 5px;
  padding: 5px 12px;
  white-space: nowrap;
  height: 100%;
  transition: filter 0.25s ease;
}
.create-task-split .split-main:hover:not(:disabled) {
  filter: brightness(1.12);
}
.create-task-split .split-toggle {
  position: relative;
  overflow: hidden;
  border-radius: 0 5px 5px 0;
  padding: 5px 12px;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  /* asosiy tugmadan yorqinroq */
  filter: brightness(1.16);
  transition: filter 0.25s ease, box-shadow 0.25s ease;
}

/* Hoverda yorug'lik to'lqini o'tadi */
.create-task-split .split-toggle::before {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    100deg,
    transparent,
    rgba(255, 255, 255, 0.45),
    transparent
  );
  transform: skewX(-20deg);
  transition: left 0.55s ease;
  pointer-events: none;
}
.create-task-split .split-toggle:hover:not(:disabled)::before {
  left: 130%;
}

.create-task-split .split-toggle:hover:not(:disabled) {
  filter: brightness(1.34);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.create-task-split .split-toggle:active:not(:disabled) {
  filter: brightness(1.05);
}

/* Bootstrap caret — hover va ochilganda aylanadi */
.create-task-split .split-toggle::after {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.create-task-split .split-toggle:hover:not(:disabled)::after {
  transform: translateY(1px);
}
.create-task-split .split-toggle.show::after {
  transform: rotate(180deg);
}

.create-task-split .split-toggle.show {
  filter: brightness(1.34);
}

.create-task-split .split-toggle:disabled {
  filter: brightness(1);
  opacity: 0.55;
}
.split-menu {
  border-radius: 12px;
  padding: 8px;
  min-width: 280px;
  background-color: #fff;
  z-index: 9999 !important;
}
.split-menu .dropdown-item {
  border-radius: 8px;
  padding: 10px 10px;
  gap: 12px;
  white-space: normal;
}
.split-menu .dropdown-item:hover {
  background-color: #f3f6f9;
}
.split-menu-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(16, 185, 129, 0.12);
  color: #059669;
  font-size: 14px;
}
.split-menu-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}
.split-menu-desc {
  display: block;
  font-size: 11px;
  color: #878a99;
  line-height: 1.3;
}

/* ========================================================= */
/* HEADER ACTION ICONS (bir tekislikda) */
/* ========================================================= */
.header-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: nowrap;
}
.header-action-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  color: #405189;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.header-action-item:hover {
  background-color: rgba(64, 81, 137, 0.08);
  transform: translateY(-1px);
  color: #405189;
}
.header-action-item.is-danger {
  color: #e33131;
}
.header-action-item.is-danger:hover {
  background-color: rgba(227, 49, 49, 0.08);
  color: #e33131;
}
.header-action-item i {
  font-size: 22px;
  line-height: 1;
}
.header-action-badge {
  position: absolute;
  top: -2px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  border: 2px solid #ffffff;
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
}

/* ========================================================= */
/* CREATIVE AVATAR GROUP (Hover spread & bounce) */
/* ========================================================= */
.creative-avg {
  display: flex;
  align-items: center;
  transition: all 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);
  padding: 5px 0;
}
.creative-avg-item {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 3px 6px rgba(0,0,0,0.08);
  margin-left: -12px;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  cursor: pointer;
  background: #f1f5f9;
  z-index: 1;
}
.creative-avg-item:first-child {
  margin-left: 0;
}
.creative-avg-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.creative-avg-initials {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: #3b82f6;
  background: #eff6ff;
  transition: all 0.3s ease;
}

.creative-avg-item:hover .creative-avg-initials {
  background: #3b82f6;
  color: #ffffff;
}

/* Spread them out on hover */
.creative-avg:hover .creative-avg-item {
  margin-left: 2px;
}

/* Hover individual effect */
.creative-avg-item:hover {
  transform: translateY(-5px) scale(1.15) !important;
  z-index: 10;
  box-shadow: 0 10px 15px -3px rgba(59,130,246,0.3), 0 4px 6px -2px rgba(59,130,246,0.2);
  border-color: #eff6ff;
}

.creative-avg-item.active {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.4);
  transform: translateY(-5px);
  z-index: 5;
}
.creative-avg-item.active .creative-avg-initials {
  background: #10b981;
  color: white;
}

/* The clear button */
.creative-avg-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fee2e2, #fca5a5);
  border-color: #fff;
  color: #b91c1c;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.creative-avg-clear i {
  font-size: 14px;
}
.creative-avg-clear:hover {
  background: linear-gradient(135deg, #fca5a5, #ef4444);
  color: #fff;
  border-color: #fca5a5;
  box-shadow: 0 10px 15px -3px rgba(239, 68, 68, 0.4);
}
/* Premium Task List Dialog Styles */
.premium-task-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 16px;
}
.premium-task-card {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
  min-height: 180px;
}
.premium-task-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
  transform: translateY(-2px);
}
.task-card-id {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  width: fit-content;
}
.task-card-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}
.task-card-desc {
  font-size: 13.5px;
  color: #64748b;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
}
.task-card-meta {
  font-size: 12.5px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 8px;
}
.task-card-meta i {
  font-size: 14px;
}
.premium-badge {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  font-size: 11px;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.premium-avatar {
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  width: 28px !important;
  height: 28px !important;
}
</style>
